<div *ngIf="setupComplete">
	<div *ngIf="staffMode" class="title-bar">
		<nav aria-label="breadcrumb">
			<ol *ngIf="pageMode === 'activation'" class="breadcrumb">
				<li class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1">
					</fa-icon>
					<a [routerLink]="['/' + ac.urls.licensing]">Key Search</a>
				</li>
				<li *ngIf="activation" class="breadcrumb-item active" aria-current="page">
					{{ activation.key }}
				</li>

				<li *ngIf="activation && (activation.info || activation.ext_label)" class="breadcrumb-item active" aria-current="page">
					{{ activation.ext_label ? activation.ext_label : activation.info}}
				</li>
			</ol>

			<ol *ngIf="pageMode === 'hostid'" class="breadcrumb">
				<li *ngIf="!showLinkOfflineLicense" class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1">
					</fa-icon>
					<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.licensing]">Licensing</a>
				</li>

				<li *ngIf="!showLinkOfflineLicense && filterID !== 0 && filterKey !== ''" class="breadcrumb-item">
					<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.licensing, filterID]">
						{{ filterKey }}
					</a>
				</li>

				<li *ngIf="showLinkOfflineLicense" class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1">
					</fa-icon>
					<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.licensing, 'offline']">Licensing</a>
				</li>

				<li class="breadcrumb-item active" aria-current="page">
					{{ hostid }}
				</li>
			</ol>

			<ol *ngIf="pageMode === 'ip'" class="breadcrumb">
				<li class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1">
					</fa-icon>
					<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.licensing]">Licensing</a>
				</li>

				<li class="breadcrumb-item active" aria-current="page">
					{{ ip }}
				</li>
			</ol>

			<ol *ngIf="pageMode === 'aggregate'" class="breadcrumb">
				<li class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1">
					</fa-icon>
					<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.licensing]">Licensing</a>
				</li>
				<li class="breadcrumb-item active" aria-current="page">
					Aggregate
				</li>
			</ol>
		</nav>

		<div class="actions">
			<div class="form-inline">

				<div *ngIf="activation && pageMode === 'activation'" class="btn-group">
					<button type="button" class="btn btn-outline-secondary" [routerLink]="['/' + ac.urls.mykeys, activation.key]"
						ngbTooltip="View the key in the same way a non-staff user sees it." placement="bottom-end">
						<fa-icon [icon]="['fas', 'glasses']"></fa-icon>
						<span class="cp-action-button-text">User View</span>
					</button>

					<button *ngIf="actionsReady && showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Compact Data Sizes" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="actionsReady && !showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Expanded Data Sizes in Base Unit (megabytes)" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="actionsReady && canManageKey" type="button" class="btn btn-outline-primary"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'edit']" ngbTooltip="Edit" placement="bottom-end">
						<fa-icon icon="pencil"></fa-icon>
						<!-- <span class="cp-action-button-text">Edit</span> -->
					</button>

					<button *ngIf="actionsReady && canConfigureMarketplace" type="button" class="btn btn-outline-primary"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'marketplace']" ngbTooltip="Set/Unset Marketplace Reporting"
						placement="bottom-end">
						<fa-icon [icon]="ac.sectionIcons.marketplace"></fa-icon>
					</button>

					<button *ngIf="actionsReady && canManageKeyViaTemplate" type="button" class="btn btn-outline-primary" (click)="clone()"
						ngbTooltip="Copy/Clone" placement="bottom-end">
						<fa-icon icon="clone"></fa-icon>
						<!-- <span class="cp-action-button-text">Clone</span> -->
					</button>

					<button *ngIf="actionsReady && canSetWriteAccess" type="button" class="btn btn-outline-primary"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'write-access']" ngbTooltip="Grant Write Access"
						placement="bottom-end">
						<fa-icon icon="lock"></fa-icon>
						<!-- <span class="cp-action-button-text">Edit</span> -->
					</button>

					<button *ngIf="actionsReady && canSetTemplate" type="button" class="btn btn-outline-primary"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'link-template']"
						ngbTooltip="Set the Template that this key uses." placement="bottom-end">
						<fa-icon [icon]="['fas', 'link']"></fa-icon>
						<span class="cp-action-button-text">Set Template</span>
					</button>

					<button type="button" class="btn btn-outline-secondary" (click)="loadData()" [disabled]="loading">
						<fa-icon icon="sync-alt" [spin]="loading" ngbTooltip="Refresh" placement="bottom-end">
						</fa-icon>
						<!-- <span class="cp-action-button-text">Refresh</span> -->
					</button>

					<button *ngIf="prevId > 0" type="button" class="btn btn-outline-secondary" (click)="routeToKey(prevId)"
						[ngbTooltip]="prevNote" placement="bottom-end">
						<fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
						<!-- Prev -->
					</button>

					<button *ngIf="nextId > 0" type="button" class="btn btn-outline-secondary" (click)="routeToKey(nextId)"
						[ngbTooltip]="nextNote" placement="bottom-end">
						<fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
						<!-- Next -->
					</button>
				</div>

				<div *ngIf="pageMode === 'hostid'" class="btn-group">
					<button *ngIf="filterID !== 0 && filterKey !== ''" type="button" class="btn btn-outline-secondary"
						[routerLink]="['/' + ac.urls.mykeys, filterKey, 'host', hostid]"
						ngbTooltip="View the host ID in the same way a non-staff user sees it." placement="bottom-end">
						<fa-icon [icon]="['fas', 'glasses']"></fa-icon>
						<span class="cp-action-button-text">User View</span>
					</button>

					<button *ngIf="actionsReady && showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Compact Data Sizes" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="actionsReady && !showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Expanded Data Sizes in Base Unit (megabytes)" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button type="button" class="btn btn-outline-secondary" [disabled]="loading" (click)="loadData()">
						<fa-icon icon="sync-alt" [spin]="loading" ngbTooltip="Refresh" placement="bottom-end">
						</fa-icon>
						<!-- <span class="cp-action-button-text">Refresh</span> -->
					</button>
				</div>

				<div *ngIf="pageMode === 'aggregate'" class="btn-group">
					<button *ngIf="actionsReady && showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Compact Data Sizes" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="actionsReady && !showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Expanded Data Sizes in Base Unit (megabytes)" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="!staffMode" class="title-bar">
		<nav aria-label="breadcrumb">
			<ol *ngIf="pageMode === 'activation'" class="breadcrumb">
				<li class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.mykeys" class="cp-user-nav-item me-1"></fa-icon>
					<a [routerLink]="['/' +  ac.urls.mykeys]">License Keys</a>
				</li>
				<li *ngIf="activation" class="breadcrumb-item active" aria-current="page">
					{{ activation.key }}
				</li>

				<li *ngIf="activation && (activation.ext_label || (userKey && userKey.label))" class="breadcrumb-item active"
					aria-current="page">
					{{ (userKey && userKey.label) ? userKey.label : activation.ext_label}}
				</li>

			</ol>

			<ol *ngIf="pageMode === 'hostid'" class="breadcrumb">
				<li class="breadcrumb-item">
					<fa-icon [icon]="ac.sectionIcons.mykeys" class="cp-user-nav-item me-1"></fa-icon>
					<a [routerLink]="['/' +  ac.urls.mykeys]">License Keys</a>
				</li>
				<li *ngIf="activation" class="breadcrumb-item">
					<a [routerLink]="['/' +  ac.urls.mykeys, activation.key]">{{ activation.key }}</a>
				</li>
				<li class="breadcrumb-item active" aria-current="page">
					{{ hostid }}
				</li>
			</ol>
		</nav>

		<div class="actions">
			<div class="form-inline">
				<div *ngIf="pageMode === 'activation'" class="btn-group">
					<button *ngIf="showAdminButton && userKey" type="button" class="btn btn-outline-secondary"
						[routerLink]="['/' + ac.urls.licensing,  'activation', userKey.activation_id]"
						ngbTooltip="Switch to the Staff/Admin view of this key" placement="bottom">
						<fa-icon [icon]="['fas', 'glasses']"></fa-icon>
						Staff View
					</button>

					<button *ngIf="!loading && showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Compact Data Sizes" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="!loading && !showRawData" type="button" class="btn btn-outline-secondary" (click)="toggleShowRaw()"
						ngbTooltip="Show Expanded Data Sizes in Base Unit (megabytes)" placement="bottom-end">
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
						<fa-icon [icon]="['fas', 'hashtag']"></fa-icon>
					</button>

					<button *ngIf="registeredKey && orgUsers && orgUsers.length !== 0 && userKey.is_deleted === 0" type="button"
						class="btn btn-outline-primary" [routerLink]="['/' + ac.urls.mykeys, userKey.id,  'share']"
						ngbTooltip="Share keys with members of your organization" placement="bottom-end">
						<fa-icon [icon]="['fas', 'share-alt']"></fa-icon>
						<span class="cp-action-button-text">Share</span>
					</button>

					<button *ngIf="registeredKey && userKey && userKey.is_deleted === 0" type="button" class="btn btn-outline-primary"
						(click)="editKeyLabel()" ngbTooltip="Add/change a label for this key" placement="bottom-end">
						<fa-icon icon="pencil"></fa-icon>
						<span class="cp-action-button-text">Edit</span>
					</button>

					<button *ngIf="registeredKey && userKey && userKey.is_deleted === 0" type="button" class="btn btn-outline-danger"
						(click)="delete()" ngbTooltip="Move this key to the trash" placement="bottom-end">
						<fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
						<!-- <span class="cp-action-button-text">Delete</span> -->
					</button>

					<button *ngIf="registeredKey && userKey && userKey.is_deleted === 1" type="button" class="btn btn-outline-primary"
						(click)="recover()" ngbTooltip="Take this key out of the trash" placement="bottom-end">
						<fa-icon [icon]="['fas', 'life-ring']"></fa-icon>
						<!-- <span class="cp-action-button-text">Recover</span> -->
					</button>

					<button *ngIf="registeredKey && userKey && showPurge" type="button" class="btn btn-outline-danger" (click)="purge()"
						ngbTooltip="Permanently remove this keys from your account" placement="bottom-end">
						<fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
						<!-- <span class="cp-action-button-text">Purge</span> -->
					</button>

					<button type="button" class="btn btn-outline-secondary" (click)="loadData(true)">
						<fa-icon icon="sync-alt" [spin]="loading" ngbTooltip="Refresh" placement="bottom-end">
						</fa-icon>
						<!-- <span class="cp-action-button-text">Refresh</span> -->
					</button>

					<button *ngIf="prevId > 0" type="button" class="btn btn-outline-secondary" (click)="routeToKey(prevId)"
						[ngbTooltip]="prevNote" placement="bottom-end">
						<fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
						<!-- Prev -->
					</button>

					<button *ngIf="nextId > 0" type="button" class="btn btn-outline-secondary" (click)="routeToKey(nextId)"
						[ngbTooltip]="nextNote" placement="bottom-end">
						<fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
						<!-- Next -->
					</button>
				</div>

				<div *ngIf="pageMode === 'hostid'" class="btn-group">
					<button *ngIf="showAdminButton && activation" type="button" class="btn btn-outline-secondary"
						[routerLink]="['/' + ac.urls.licensing, 'hostid', hostid, activation.id]"
						ngbTooltip="Switch to the Staff/Admin view of this host ID" placement="bottom">
						<fa-icon [icon]="['fas', 'glasses']"></fa-icon>
						Staff View
					</button>

					<button *ngIf="registeredKey" type="button" class="btn btn-outline-primary" (click)="editHostIdLabel()"
						placement="bottom-end" ngbTooltip="Add/change a label for this host ID.">
						<fa-icon icon="pencil"></fa-icon>
						<span class="cp-action-button-text">Edit</span>
					</button>

					<span *ngIf="!registeredKey" class="btn btn-outline-primary" placement="bottom-end"
						ngbTooltip="You can only set a label on a host ID from a key linked to your account">
						<fa-icon icon="pencil"></fa-icon>
						<span class="cp-action-button-text">Edit</span>
					</span>

					<button type="button" class="btn btn-outline-secondary" (click)="loadData(true)">
						<fa-icon icon="sync-alt" [spin]="loading" ngbTooltip="Refresh" placement="bottom-end">
						</fa-icon>
						<!-- <span class="cp-action-button-text">Refresh</span> -->
					</button>
				</div>

			</div>
		</div>
	</div>

	<div class="clearfix"></div>

	<div class="tab-container">
		<ul *ngIf="pageMode === 'activation'" class="cp-nav-tabs" id="myTab" role="tablist">
			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
					id="nav-base-tab" aria-controls="nav-base" data-bs-target="#nav-base">
					<fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
					Info
				</button>
			</li>

			<li *ngIf="staffMode" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-commercial-tab" aria-controls="nav-commercial" data-bs-target="#nav-commercial">
					<fa-icon [icon]="['fas', 'sack-dollar']"></fa-icon>
					Commercial
				</button>
			</li>

			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-activations-tab" aria-controls="nav-activations" data-bs-target="#nav-activations">
					<fa-icon [icon]="['fas', 'server']"></fa-icon>
					Activations
					<span *ngIf="activation && (!loading || activation.licenses.length) " class="cp-tab-badge">
						{{ activation.licenses.length | number }}<span *ngIf="showMaxHostsExtra">+</span>
					</span>
				</button>
			</li>

			<li *ngIf="activeLicenses.length > 0" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-active-tab" aria-controls="nav-active" data-bs-target="#nav-active">
					<fa-icon [icon]="['fas', 'bolt']"></fa-icon>
					Active
					<span class="cp-tab-badge">
						{{ activeLicenses.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="showMaxHostsExtra" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-search-tab" aria-controls="nav-search" data-bs-target="#nav-search">
					<fa-icon [icon]="['fas', 'search']"></fa-icon>
					Search
				</button>
			</li>

			<li *ngIf="staffMode && failedPenTests && failedPenTests.length !== 0" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-pen-test-tab" aria-controls="nav-pen-test" data-bs-target="#nav-pen-test">
					<fa-icon [icon]="['fas', 'lock-open']"></fa-icon>
					Pen Tests
					<span class="cp-tab-badge">
						{{ failedPenTests.length | number }}
					</span>
				</button>
			</li>

			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-features-tab" aria-controls="nav-features" data-bs-target="#nav-features">
					<fa-icon [icon]="['fas', 'clipboard-list-check']"></fa-icon>
					Features/Limits
				</button>
			</li>

			<li *ngIf="showMetersTab" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-meters-tab" aria-controls="nav-meters" data-bs-target="#nav-meters">
					<fa-icon [icon]="ac.meterIcon"></fa-icon>
					{{ metersTabLabel }}
					<span *ngIf="activation && showMeters && activation.meters.length > 0" class="cp-tab-badge">
						{{ activation.meters.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="showMeterTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-meter-traffic-tab" aria-controls="nav-meter-traffic" data-bs-target="#nav-meter-traffic"
					ngbTooltip="Meter Traffic">
					<fa-icon [icon]="ac.meterIcon"></fa-icon>
					Traffic<sup>m</sup>
				</button>
			</li>

			<li *ngIf="showProtocolTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-protocol-traffic-tab" aria-controls="nav-protocol-traffic" data-bs-target="#nav-protocol-traffic"
					ngbTooltip="Protocol Traffic">
					<fa-icon [icon]="ac.protocolIcon"></fa-icon>
					Traffic<sup>p</sup>
				</button>
			</li>

			<li *ngIf="showProtocolTraffic && (bcSummaryByHostId.length > 0 || invalidBillingCodeEntries.length > 0 || lotsOfBillingCodes)"
				class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-bc-summary-tab" aria-controls="nav-bc-summary" data-bs-target="#nav-bc-summary"
					ngbTooltip="Billing Code Summary by Host ID">
					<fa-icon [icon]="['fas', 'sack-dollar']">
					</fa-icon>
					B.C. Summary
				</button>
			</li>

			<li *ngIf="staffMode" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-users-tab" aria-controls="nav-users" data-bs-target="#nav-users">
					<fa-icon [icon]="ac.sectionIcons.users"></fa-icon>
					Users
					<span *ngIf="!loading && userKeys && userKeys.length > 0" class="cp-tab-badge">
						{{ userKeys.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="staffMode" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-journal-tab" aria-controls="nav-journal" data-bs-target="#nav-journal" ngbTooltip="Journal Entries">
					<fa-icon [icon]="ac.sectionIcons.journals"></fa-icon>
					<!-- Journal -->
					<span *ngIf="journals && journals.length > 0" class="cp-tab-badge">
						{{ journals.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="staffMode && (marketplaceLabel !== '' || marketplaceLogs.length > 0)" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-marketplace-log-tab" aria-controls="nav-marketplace-log" data-bs-target="#nav-marketplace-log"
					ngbTooltip="Marketplace Log">
					<fa-icon [icon]="ac.sectionIcons.marketplace"></fa-icon>
					<!-- marketplace -->
				</button>
			</li>

			<li *ngIf="staffMode" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-admin-log-tab" aria-controls="nav-admin-log" data-bs-target="#nav-admin-log" ngbTooltip="History/Change Log">
					<fa-icon [icon]="ac.sectionIcons.adminlogs"></fa-icon>
					<!-- Log -->
				</button>
			</li>

			<li *ngIf="!staffMode && sharedWithUsers.length !== 0" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-shares-tab" aria-controls="nav-shares" data-bs-target="#nav-shares">
					<fa-icon [icon]="ac.sectionIcons.users"></fa-icon>
					Shared With
					<span *ngIf="activation && (!loading || sharedWithUsers.length) " class="cp-tab-badge">
						{{ sharedWithUsers.length | number }}
					</span>
				</button>
			</li>

			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</ul>

		<ul *ngIf="pageMode === 'hostid'" class="cp-nav-tabs" id="myTab" role="tablist">
			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
					id="nav-activation-details-tab" aria-controls="nav-activation-details" data-bs-target="#nav-activation-details">
					<fa-icon [icon]="['fas', 'key']"></fa-icon>
					Activations
					<span *ngIf="licenses && licenses.length > 1" class="cp-tab-badge">
						{{ licenses.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="staffMode && labels.length !== 0" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-host-labels-tab" aria-controls="nav-host-labels" data-bs-target="#nav-host-labels">
					<fa-icon [icon]="['fas', 'pencil']"></fa-icon>
					Labels
					<span class="cp-tab-badge">
						{{ labels.length | number }}
					</span>
				</button>
			</li>

			<li *ngIf="showMeterTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-meter-traffic-tab" aria-controls="nav-meter-traffic" data-bs-target="#nav-meter-traffic"
					ngbTooltip="Meter Traffic">
					<fa-icon [icon]="ac.meterIcon"></fa-icon>
					Traffic<sup>m</sup>
				</button>
			</li>

			<li *ngIf="showProtocolTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-protocol-traffic-tab" aria-controls="nav-protocol-traffic" data-bs-target="#nav-protocol-traffic"
					ngbTooltip="Protocol Traffic">
					<fa-icon [icon]="ac.protocolIcon"></fa-icon>
					Traffic<sup>p</sup>
				</button>
			</li>

			<li *ngIf="staffMode && showProtocolTraffic && (bcSummaryByHostId.length > 0 || invalidBillingCodeEntries.length > 0 || lotsOfBillingCodes)"
				class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-compact-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-bc-summary-tab" aria-controls="nav-bc-summary" data-bs-target="#nav-bc-summary"
					ngbTooltip="Billing Code Summary by Host ID">
					<fa-icon [icon]="['fas', 'sack-dollar']">
					</fa-icon>
					B.C. Summary
				</button>
			</li>

			<li *ngIf="historyLoading || versionHistory.length !== 0" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-versions-tab" aria-controls="nav-versions" data-bs-target="#nav-versions">
					<fa-icon [icon]="['fas', 'history']"></fa-icon>
					Version History
				</button>
			</li>

			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</ul>

		<ul *ngIf="staffMode && pageMode === 'ip'" class="cp-nav-tabs" id="myTab" role="tablist">
			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
					id="nav-activation-details-tab" aria-controls="nav-activation-details" data-bs-target="#nav-activation-details">
					<fa-icon [icon]="['fas', 'key']"></fa-icon>
					Activations
					<span *ngIf="licenses && licenses.length > 1" class="cp-tab-badge">
						{{ licenses.length | number }}
					</span>
				</button>
			</li>

			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</ul>

		<ul *ngIf="staffMode && pageMode === 'aggregate'" class="cp-nav-tabs" id="myTab" role="tablist">
			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
					id="nav-aggregate-items-tab" aria-controls="nav-aggregate-items" data-bs-target="#nav-aggregate-items">
					<fa-icon [icon]="['fas', 'key']"></fa-icon>
					What to Aggregate?
				</button>
			</li>

			<li class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-item-details-tab" aria-controls="nav-item-details" data-bs-target="#nav-item-details">
					<fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
					Info
				</button>
			</li>

			<li *ngIf="showMeterTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-meter-traffic-tab" aria-controls="nav-meter-traffic" data-bs-target="#nav-meter-traffic"
					ngbTooltip="Meter Traffic">
					<fa-icon [icon]="ac.meterIcon"></fa-icon>
					Traffic<sup>m</sup>
				</button>
			</li>

			<li *ngIf="showProtocolTraffic" class="cp-nav-item" role="presentation">
				<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
					id="nav-protocol-traffic-tab" aria-controls="nav-protocol-traffic" data-bs-target="#nav-protocol-traffic"
					ngbTooltip="Protocol Traffic">
					<fa-icon [icon]="ac.protocolIcon"></fa-icon>
					Traffic<sup>p</sup>
				</button>
			</li>

			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</ul>

		<div class="tab-content" id="nav-tabContent">
			<!-- activation tab panels -->
			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane show active" role="tabpanel" id="nav-base"
				aria-labelledby="nav-base-tab">

				<div *ngIf="failedPenTestIPs && failedPenTestIPs.length !== 0" class="cp-danger-message mb-2">
					<fa-icon [icon]="['fas', 'lock-open']" class="me-1">
					</fa-icon>
					This key has one or more activations from {{ failedPenTestIPs.length }} IP Address{{
					failedPenTestIPs.length > 1 ? 'es' : '' }} that are open to the internet and use the default username
					and password. See the Failed Pen Test tab.
				</div>

				<div *ngIf="!!activation && keyWarnings && keyWarnings.length !== 0" class="cp-warning-message mb-2">
					<div *ngFor="let item of keyWarnings">
						<fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
						{{ item }}
					</div>
				</div>

				<div *ngIf="!!activation && (meterWarnings.length !== 0 || nonEnforcedWarnings.length !== 0)"
					class="cp-warning-message mb-2">
					<div *ngFor="let item of meterWarnings">
						<fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
						{{ item }}
					</div>
					<div *ngFor="let item of nonEnforcedWarnings">
						<fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
						{{ item }}
					</div>
				</div>

				<div *ngIf="activation" class="cp-width-limit-1400">
					<div class="row justify-content-start g-1">
						<div class="col-6 px-0">
							<div class="bg-light border m-1 p-1">
								<div class="cp-property-block" *ngIf="!loading && !organization">
									<span class="cp-property-label">Organization:</span>
									<span class="cp-property-value">Not linked
									</span>
								</div>

								<div class="cp-property-block" *ngIf="organization">
									<span class="cp-property-label">Organization:</span>
									<span class="cp-property-value">
										<a [routerLink]="['/' + ac.urls.organizations, organization.id]" [ngbPopover]="orgPopupContent"
											popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
											{{ organization.name }}
										</a>
										({{ ac.organizationTypeLabels[organization.otype] }})
										<fa-icon *ngIf="organization.is_enabled === 0" [icon]="['fas', 'ban']" class="text-danger ms-1"
											ngbTooltip="Organization is not enabled"></fa-icon>
									</span>

									<ng-template #orgPopupContent>
										<app-card-organization [object]="organization"></app-card-organization>
									</ng-template>
								</div>

								<div class="cp-property-block"
									*ngIf="organization && (organization.salesforce_account_owner || accountOwner)">
									<span class=" cp-property-label">Account Owner:</span>
									<span class="cp-property-value">
										<span *ngIf="!accountOwner">
											{{ organization.salesforce_account_owner }}
										</span>
										<a *ngIf="accountOwner" [routerLink]="['/' + ac.urls.users, accountOwner.id]"
											[ngbPopover]="userPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
											container="body">
											{{ accountOwner.name }}

											<ng-template #userPopupContent>
												<app-card-user [object]="accountOwner"></app-card-user>
											</ng-template>
										</a>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="organization && (organization.salesforce_se || accountSE)">
									<span class=" cp-property-label">Sales Engineer:</span>
									<span class="cp-property-value">
										<span *ngIf="!accountSE">
											{{ organization.salesforce_se }}
										</span>
										<a *ngIf="accountSE" [routerLink]="['/' + ac.urls.users, accountSE.id]"
											[ngbPopover]="userPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
											container="body">
											{{ accountSE.name }}
											<ng-template #userPopupContent>
												<app-card-user [object]="accountSE"></app-card-user>
											</ng-template>
										</a>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="organization && (organization.salesforce_tam || accountTAM)">
									<span class=" cp-property-label">Technical Account Manager:</span>
									<span class="cp-property-value">
										<span *ngIf="!accountTAM">
											{{ organization.salesforce_tam }}
										</span>
										<a *ngIf="accountTAM" [routerLink]="['/' + ac.urls.users, accountTAM.id]"
											[ngbPopover]="userPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
											container="body">
											{{ accountTAM.name }}
											<ng-template #userPopupContent>
												<app-card-user [object]="accountTAM"></app-card-user>
											</ng-template>
										</a>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="organization && (organization.salesforce_sa || accountSA)">
									<span class=" cp-property-label">Solutions Architect:</span>
									<span class="cp-property-value">
										<span *ngIf="!accountSA">
											{{ organization.salesforce_sa }}
										</span>
										<a *ngIf="accountSA" [routerLink]="['/' + ac.urls.users, accountSA.id]"
											[ngbPopover]="userPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
											container="body">
											{{ accountSA.name }}

											<ng-template #userPopupContent>
												<app-card-user [object]="accountSA"></app-card-user>
											</ng-template>
										</a>
									</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">{{ ac.keyInfoFieldLabel }} (Internal):</span>
									<span class="cp-property-value">{{ activation.info }}</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Key:</span>
									<span class="cp-property-value">
										<span class="cp-key">{{ activation.key }}</span>
										<fa-icon [icon]="['fas', 'copy']" ngxClipboard (click)="copyToClipboardAlert(activation.key)"
											[cbContent]="activation.key" ngbTooltip="Copy to Clipboard" placement="end"
											class="ms-1"></fa-icon>
									</span>
								</div>

								<div *ngIf="!slt.isSpecialKey(activation)" class="cp-property-block">
									<span class="cp-property-label">Enabled:</span>
									<span *ngIf="activation.enabled === 1" class="cp-property-value">
										Yes
										<button *ngIf="canManageKey" type="button" class="btn btn-outline-primary btn-sm ms-1"
											(click)="prepDisable()">
											<fa-icon [icon]="['fas', 'ban']" class="text-danger"></fa-icon>
											Disable Key
										</button>
									</span>
									<span *ngIf="activation.enabled === 0" class="cp-property-value text-danger">
										No
										<button *ngIf="canManageKey" type="button" class="btn btn-outline-primary btn-sm ms-1"
											(click)="enableKey()">
											<fa-icon [icon]="['fas', 'power-off']" class="text-success"></fa-icon>
											Enable Key
										</button>
									</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Product:</span>
									<span *ngIf="keyProduct" class="cp-property-value">
										<a [routerLink]="['/' + ac.urls.licensingadmin, 'products', keyProduct.id]"
											[ngbPopover]="keyProductPopupContent" popoverClass="cp-popover-std"
											triggers="mouseenter:mouseleave" container="body">
											{{ keyProduct.label }}
										</a> ({{ keyProduct.name }})
									</span>
									<span *ngIf="!keyProduct" class="cp-property-value">
										{{ activation.product }}
									</span>
									<ng-template #keyProductPopupContent>
										<app-card-key-product [object]="keyProduct"></app-card-key-product>
									</ng-template>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Type:</span>
									<span [class]="'cp-key-type-' + activation.type">
										{{ niceKeyType(activation) | titlecase }}
									</span>
								</div>

								<div class="cp-property-block"
									*ngIf="activation.contacts && activation.contacts !== '' && activation.contacts.trim() !== '--- []'">
									<span class="cp-property-label">Contacts:</span>
									<span class="cp-property-value">{{ activation.contacts }}</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Activations:</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': +activation.count >= +activation.max }">
										{{ activation.count | number }} of {{ activation.max | number }} used
										<button *ngIf="showOfflineButton" type="button" class="btn btn-outline-primary btn-sm ms-1"
											[routerLink]="['/' + ac.urls.licensing, activation.id, 'offline']">
											<fa-icon [icon]="['fas', 'lightbulb-slash']"></fa-icon>
											Create Offline License(s)
										</button>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="recentUsedHosts.length !== 0">
									<span class="cp-property-label">
										# Active/Recent Host IDs
										<fa-icon [icon]="['fas', 'question-circle']" [ngbTooltip]="recentHostsPopup"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ recentUsedHosts.length | number }}
									</span>
								</div>

								<div *ngIf="expiryMode && expiryMode !== ''" class="cp-property-block">
									<span class="cp-property-label">Expiration Mode:</span>
									<span class="cp-property-value">
										{{ slt.niceKeyExpiryMode(expiryMode, true) }}
										<fa-icon [icon]="['fas', 'question-circle']" [ngbTooltip]="slt.niceKeyExpiryMode(expiryMode, false)"
											placement="bottom-start">
										</fa-icon>
										<span *ngIf="activation.enabled === 0 && !slt.isSpecialKey(activation)">
											- Key is not enabled</span>
									</span>
								</div>

								<div *ngIf="activation.enabled === 1 && expiryMode && expiryMode === 'meter'" class="cp-property-block">
									<!-- <span class="cp-property-label">Expiry:</span>
								<span class="cp-property-value">See meters</span> -->
									<span *ngIf="mt.hasExpired(keyExpiryCalc)" class="cp-property-label">Expired
										(meter):</span>
									<span *ngIf="!mt.hasExpired(keyExpiryCalc)" class="cp-property-label">Expires
										(meter):</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': mt.hasExpired(keyExpiryCalc)}">
										{{ keyExpiryCalc | date: ac.shortPageDateFmt:'UTC' }}
										- {{ tt.niceExpireText(keyExpiryCalc) }}
									</span>
								</div>

								<div *ngIf="expiryMode && expiryMode === 'date' && activation.expires_at" class="cp-property-block">
									<span *ngIf="mt.hasExpired(activation.expires_at)" class="cp-property-label">Expired:</span>
									<span *ngIf="!mt.hasExpired(activation.expires_at)" class="cp-property-label">Expires:</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': mt.hasExpired(activation.expires_at)}">
										{{ activation.expires_at | date: ac.shortPageDateFmt:'UTC' }}
										- {{ tt.niceExpireText(activation.expires_at) }}
									</span>
								</div>

								<div *ngIf="expiryMode && expiryMode === 'duration' && activation.duration && activation.duration !== 0"
									class="cp-property-block">
									<span class="cp-property-label">
										Duration
										<fa-icon [icon]="['fas', 'question-circle']" ngbTooltip="Lifespan of licenses from date of issue"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">{{
										slt.niceKeyDuration(activation.duration)
										}}</span>
								</div>

								<div class="cp-property-block" *ngIf="showMeters && activation.first_meter_report">
									<span class="cp-property-label">
										Meter Reporting
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in against a meter"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_meter_report | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_meter_report | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="showMeters && activation.first_meter_usage">
									<span class="cp-property-label">
										Meter Usage
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in non-zero traffic against a meter"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_meter_usage | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_meter_usage | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="protocolReady && activation.first_protocol_report">
									<span class="cp-property-label">
										Protocol Reporting
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in protocol traffic"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_protocol_report | date: ac.shortPageDateFmt:'UTC' }}
										to
										{{ activation.last_protocol_report | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="protocolReady && activation.first_protocol_usage">
									<span class="cp-property-label">
										Protocol Usage
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in non-zero protocol traffic"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_protocol_usage | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_protocol_usage | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="lpUser && lpUser !== ''">
									<span class="cp-property-label">
										Last Touched By:
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="If the key was created using the old/legacy license portal, what user created or last updated it"
											placement="bottom-start">
										</fa-icon>
									</span>
									<span class="cp-property-value">{{ lpUser }}</span> [via License Portal]
								</div>

								<div *ngIf="activation.created_at" class="cp-property-block">
									<span class="cp-property-label">Added:</span>
									<span class="cp-property-value">
										{{ activation.created_at | date: ac.shortPageDateTimeFmt }}
										<span *ngIf="addedByUser"> by
											<a [routerLink]="['/' + ac.urls.users, addedByUser.id  ]" [ngbPopover]="userPopupContent"
												popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
												{{ addedByUser.name }}</a>

											<ng-template #userPopupContent>
												<app-card-user [object]="addedByUser"></app-card-user>
											</ng-template>
										</span>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="activation.created_at !== updatedDateToShow">
									<span class="cp-property-label">Edited:</span>
									<span class="cp-property-value">
										{{ updatedDateToShow | date: ac.shortPageDateTimeFmt }}
										<span *ngIf="editedByUser"> by
											<a [routerLink]="['/' + ac.urls.users, editedByUser.id  ]" [ngbPopover]="userPopupContent"
												popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
												{{ editedByUser.name }}</a>
											<ng-template #userPopupContent>
												<app-card-user [object]="editedByUser"></app-card-user>
											</ng-template>
										</span>
									</span>
								</div>

								<div class="cp-property-block"
									*ngIf="organization && organization.salesforce_account_id && organization.salesforce_account_id !== ''">
									<span class="cp-property-label">Salesforce Account:</span>
									<span class="cp-property-value"><a *ngIf="salesForceUrl !== ''" target="_blank"
											href="{{ salesForceUrl }}/lightning/r/Account/{{organization.salesforce_account_id}}/view">
											{{ organization.salesforce_account_id }}
										</a>
										<span *ngIf="salesforceAccountInfoBlock === ''" class="text-success cp-pointer"
											(click)="getSalesforceInfoBlocks()" ngbTooltip="Get Info From Salesforce">
											<fa-icon [icon]="['fab', 'salesforce']" [spin]="sfFetching"></fa-icon>
										</span>

										<div *ngIf="salesforceAccountInfoBlock !== ''"
											class="border p-2 ms-4 me-4 mb-2 cp-pre-text cp-general-width-limit">
											<span class="float-end cp-pointer">
												&nbsp; <fa-icon (click)="salesforceAccountInfoBlock = ''"
													[icon]="['fas', 'times-circle']"></fa-icon>
											</span>
											{{ salesforceAccountInfoBlock }}
										</div>
									</span>
								</div>

								<div class="cp-property-block"
									*ngIf="activation.opportunity_id && activation.opportunity_id !== '' && activation.opportunity_id.length > 5">
									<span class="cp-property-label">Salesforce Opportunity:</span>
									<span class="cp-property-value">
										<a *ngIf="salesForceUrl !== ''" target="_blank"
											href="{{ salesForceUrl }}/lightning/r/Opportunity/{{ activation.opportunity_id }}/view">
											{{ activation.opportunity_id }}
										</a>
										<span *ngIf="salesforceOpportunityInfoBlock === ''" class="text-success cp-pointer"
											(click)="getSalesforceInfoBlocks()" ngbTooltip="Get Info From Salesforce">
											<fa-icon [icon]="['fab', 'salesforce']" [spin]="sfFetching"></fa-icon>
										</span>

										<div *ngIf="salesforceOpportunityInfoBlock !== ''"
											class="border p-2 ms-4 me-4 mb-2 cp-pre-text cp-general-width-limit">
											<span class="float-end cp-pointer">
												&nbsp; <fa-icon (click)="salesforceOpportunityInfoBlock = ''"
													[icon]="['fas', 'times-circle']"></fa-icon>
											</span>
											{{ salesforceOpportunityInfoBlock }}
										</div>
									</span>
								</div>

								<hr *ngIf="template || writeAccessUsers.length > 0" />

								<div class="cp-property-block" *ngIf="template">
									<span class="cp-property-label">Template:</span>
									<span class="cp-property-value">
										<a [routerLink]="['/' + ac.urls.licensingadmin, 'templates', template.id]"
											[ngbPopover]="templatePopupContent" popoverClass="cp-popover-std"
											triggers="mouseenter:mouseleave" container="body">
											{{ template.name }}
										</a>
										<ng-template #templatePopupContent>
											<app-card-key-template [object]="template"></app-card-key-template>
											<!-- <div class="cp-popover-banner">{{ template.name }}</div>
										<div class="cp-pre-text">{{
											popOverTools.getKeyTemplatePopoverLines(template).join('\n')}}</div> -->
										</ng-template>

										<button *ngIf="this.isCompliant" type="button" (click)="checkCompliance(-1, true)"
											class="btn btn-outline-primary btn-sm ms-1" [disabled]="checkingCompliance || loading"
											ngbTooltip="This key is compliant with its assigned template.">
											<fa-icon *ngIf="checkingCompliance" [icon]="['fas', 'cog']" [spin]="true">
											</fa-icon>
											<fa-icon *ngIf="!checkingCompliance" [icon]="['fas', 'check']" class="text-success"
												[spin]="checkingCompliance">
											</fa-icon>
										</button>

										<button *ngIf="!this.isCompliant" type="button" (click)="checkCompliance(-1, true)"
											class="btn btn-outline-primary btn-sm ms-1" [disabled]="checkingCompliance || loading"
											ngbTooltip="This key is not compliant with its assigned template. Click to show issue(s).">
											<fa-icon [icon]="['fas', 'exclamation-triangle']" class="text-warning"></fa-icon>
										</button>

										<!-- otherTemplates -->

										<div *ngIf="otherTemplates.length > 0" class="btn-group ms-1 dropend">
											<button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button"
												id="dropDownOtherTemplate" data-bs-toggle="dropdown" aria-haspopup="true"
												aria-expanded="false" [disabled]="checkingCompliance || loading"
												ngbTooltip="Check if this key is compliant with another template.">
												<fa-icon [icon]="['fas', 'cog']" [spin]="checkingCompliance">
												</fa-icon>
												Check Other
											</button>
											<div class="dropdown-menu cp-scrollable-menu" aria-labelledby="dropDownOtherTemplate">
												<a *ngFor="let otherTemplate of otherTemplates" class="dropdown-item"
													(click)="checkCompliance(otherTemplate.id, true)">
													{{ otherTemplate.name }}
												</a>
											</div>
										</div>
									</span>
								</div>

								<div class="cp-property-block" *ngIf="writeAccessUsers.length > 0">
									<span class="cp-property-label">Users Granted Write Access:</span>
									<span class="cp-property-value">
										<ul class="mb-0">
											<li *ngFor="let writeAccessUser of writeAccessUsers">
												<a [routerLink]="['/' + ac.urls.users, writeAccessUser.id]" [ngbPopover]="userPopupContent"
													popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
													{{ writeAccessUser.name }}</a>
												<fa-icon *ngIf="writeAccessUser.is_enabled === 0" [icon]="['fas', 'ban']"
													class="text-danger ms-1" ngbTooltip="User is not enabled"></fa-icon>

												<ng-template #userPopupContent>
													<app-card-user [object]="writeAccessUser"></app-card-user>
												</ng-template>
											</li>
										</ul>
									</span>
								</div>

								<!-- <div *ngIf="activation.enabled === 1">
								<hr />
								<div class="cp-property-block">
									<span class="cp-property-label">
										Key Expiry (Evaluated)
										<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="What is the "
										placement="bottom-start">
									</fa-icon>							
									</span>
									<span *ngIf="keyExpiryCalc" class="cp-property-value">{{ keyExpiryCalc | date:
										ac.shortPageDateFmt:'UTC' }}</span>
									<span *ngIf="!keyExpiryCalc" class="cp-property-value">Never</span>
								</div>
	
								<div class="cp-property-block">
									<span class="cp-property-label">
										License Expiry (Evaluated)
										<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="If the key was created using the old/legacy license portal, what user created or last updated it"
										placement="bottom-start">
									</fa-icon>							
									</span>
									<span *ngIf="licExpiryCalc" class="cp-property-value">{{ licExpiryCalc | date:
										ac.shortPageDateFmt:'UTC' }}</span>
									<span *ngIf="!licExpiryCalc" class="cp-property-value">Never</span>
								</div>
							</div>
							 -->

							</div>

							<div *ngIf="marketplaceLabel !== ''" class="bg-light border m-1 p-1">
								<div class="cp-property-block">
									<span class="cp-property-label">Marketplace:</span>
									<span class="cp-property-value">{{ marketplaceLabel }}</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">{{ marketPlaceAccountIdLabel }}:</span>
									<span class="cp-property-value">{{ marketplaceAccountIdentifier }}</span>
								</div>

								<div *ngIf="marketplaceProducts && marketplaceProducts.length > 0" class="cp-property-block">
									<span class="cp-property-label">Marketplace Product(s):</span>
									<span class="cp-property-value">
										<ul class="mb-0">
											<li *ngFor="let marketplaceProduct of marketplaceProducts">{{
												marketplaceProduct}}
											</li>
										</ul>
									</span>
								</div>

								<div *ngIf="selectedMarketPlaceProtocolSet != null" class="cp-property-block">
									<span class="cp-property-label">Protocol Set to Report to Marketplace:</span>
									<span class="cp-property-value" [ngbPopover]="pSetPopupContent" popoverClass="cp-popover-std"
										triggers="mouseenter:mouseleave" container="body">
										<a
											[routerLink]="['/' + ac.urls.licensingadmin, 'protocol-sets', selectedMarketPlaceProtocolSet.id]">
											{{ selectedMarketPlaceProtocolSet.name }}
										</a>
									</span>
									<ng-template #pSetPopupContent>
										<app-card-protocol-set [object]="selectedMarketPlaceProtocolSet"
											[forStaff]="true"></app-card-protocol-set>
										<!-- <div class="cp-popover-banner">{{ selectedMarketPlaceProtocolSet.name }}</div>
									<div class="cp-pre-text">{{
										popOverTools.getProtocolSetPopoverLines(selectedMarketPlaceProtocolSet,
										true).join('\n')}}</div> -->
									</ng-template>
								</div>

								<div *ngIf="lastMarketplaceUsageReported" class="cp-property-block">
									<span class="cp-property-label">Marketplace Last Reported:</span>
									<span class="cp-property-value">
										{{ lastMarketplaceUsageReported | date: ac.pageDateTimeFmt }}
									</span>
								</div>

								<button *ngIf="canReportToMarketplace" type="button" class="btn btn-outline-primary btn-sm"
									data-bs-toggle="modal" data-bs-target="#manual-marketplace-report-modal">
									<fa-icon [icon]="ac.sectionIcons.marketplace"></fa-icon>
									Manually Submit Marketplace Usage
								</button>
							</div>
						</div>

						<div class="col-6 px-0">
							<div *ngIf="activation.notes && activation.notes.trim() !== ''" class="bg-light border m-1 p-1 overflow-auto"
								style="max-height: 480px">
								<div class="cp-property-block">
									<span class="cp-property-label">Notes (Internal):</span>
									<div class="cp-property-value cp-pre-text">
										{{ activation.notes.trim() }}
									</div>
								</div>
							</div>

							<div *ngIf="(activation.ext_label && activation.ext_label.trim() !== '') || (activation.ext_notes && activation.ext_notes.trim() !== '')"
								class="bg-light border m-1 p-1 overflow-auto" style="max-height: 480px">
								<div *ngIf="activation.ext_label && activation.ext_label.trim() !== ''" class="cp-property-block">
									<span class="cp-property-label">Label (External):</span>
									<span class="cp-property-value">{{ activation.ext_label }}</span>
								</div>

								<div *ngIf="activation.ext_notes && activation.ext_notes.trim() !== ''" class="cp-property-block">
									<span class="cp-property-label">Notes (External):</span>
									<div class="cp-property-value cp-pre-text">
										{{ activation.ext_notes.trim() }}
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div *ngIf="!staffMode && pageMode === 'activation'" class="tab-pane show active" role="tabpanel" id="nav-base"
				aria-labelledby="nav-base-tab">

				<div *ngIf="!loading && !registeredKey" class="cp-info-message border">
					This key isn't currently registered with your user account.
					<button type="button" class="btn btn-outline-primary btn-sm" (click)="registerKey()" placement="bottom"
						ngbTooltip="Registering a key will link this license key with your user account and it can be found under 'License Keys'.">
						Register Key</button>
				</div>

				<div *ngIf="!!activation && keyWarnings && keyWarnings.length !== 0" class="cp-warning-message mb-2">
					<div *ngFor="let item of keyWarnings">
						<fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
						{{ item }}
					</div>
				</div>

				<div *ngIf="showSelfServiceExtendButton" class="cp-info-message">
					This key no longer has any available activations. You can increase the maximum number of
					activations.<br />
					<button type="button" class="btn btn-outline-primary btn-sm" (click)="addActivationsToKey()">
						Increase the Number of Activations
					</button>
				</div>

				<div *ngIf="showSelfServiceCreateButton" class="cp-info-message">
					This key has either:
					<ul class="mb-0">
						<li>Expired</li>
						<li>or it's been disabled</li>
						<li>or it's reached the maximum allowed activations</li>
					</ul>
					You can create a new key if you wish.<br />
					<button type="button" class="btn btn-outline-primary btn-sm" (click)="generateKeyViaTemplate()">
						Create a New Key
					</button>
				</div>

				<div *ngIf="activation" style="max-width: 1400px">
					<div class="row justify-content-start g-1">
						<div class="col-6 px-0">

							<div class="bg-light border m-1 p-1">
								<div *ngIf="registeredKey" class="cp-property-block">
									<span class="cp-property-label">
										My Label:
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Your own custom label for this key. Click 'Edit' button to set/change."
											placement="bottom-start">
										</fa-icon>
									</span>
									<span class="cp-property-value">
										<span *ngIf="!userKey.label || userKey.label === ''" class='font-italic'>Not
											Set</span>
										<span *ngIf="userKey.label && userKey.label !== ''">{{ userKey.label }}</span>
									</span>
								</div>

								<div *ngIf="activation.ext_label && activation.ext_label !== ''" class="cp-property-block">
									<span class="cp-property-label">
										Label:
										<fa-icon [icon]="['fas', 'question-circle']" ngbTooltip="A label set for this key by Zixi"
											placement="bottom-start">
										</fa-icon>
									</span>
									<span class="cp-property-value">{{ activation.ext_label }}</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Key:</span>
									<span class="cp-property-value">
										<span class="cp-key">{{ activation.key }}</span>
										&nbsp;<fa-icon [icon]="['fas', 'copy']" ngxClipboard (click)="copyToClipboardAlert(activation.key)"
											[cbContent]="activation.key" ngbTooltip="Copy to Clipboard" placement="end"></fa-icon>
									</span>
								</div>

								<div *ngIf="!slt.isSpecialKey(activation)" class="cp-property-block">
									<span class="cp-property-label">Enabled:</span>
									<span *ngIf="activation.enabled === 1" class="cp-property-value">Yes</span>
									<span *ngIf="activation.enabled === 0" class="cp-property-value text-danger">No</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Product:</span>
									<span *ngIf="keyProduct" class="cp-property-value" [title]="keyProduct.name">
										{{ keyProduct.basic_label }}
									</span>
									<span *ngIf="!keyProduct" class="cp-property-value">
										{{ activation.product }}
									</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Type:</span>
									<span [class]="'cp-key-type-' + activation.type">
										{{ niceKeyType(activation) | titlecase }}
									</span>
								</div>

								<div class="cp-property-block">
									<span class="cp-property-label">Activations:</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': +activation.count >= +activation.max }">
										{{ activation.count | number }} of {{ activation.max | number }} used
									</span>
								</div>

								<div class="cp-property-block" *ngIf="recentUsedHosts.length !== 0">
									<span class="cp-property-label">
										# Active/Recent Host IDs
										<fa-icon [icon]="['fas', 'question-circle']" [ngbTooltip]="recentHostsPopup"
											placement="bottom-start">
										</fa-icon>:
									</span>
									<span class="cp-property-value">
										{{ recentUsedHosts.length | number }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="activation.created_at">
									<span class="cp-property-label">Created:</span>
									<span class="cp-property-value">{{ activation.created_at | date:
										ac.pageDateFmt }}</span>
								</div>

								<div *ngIf="expiryMode && expiryMode !== ''" class="cp-property-block">
									<span class="cp-property-label">Expiration Mode:</span>
									<span class="cp-property-value">
										{{ slt.niceKeyExpiryMode(expiryMode, true) }}
										<fa-icon [icon]="['fas', 'question-circle']" [ngbTooltip]="slt.niceKeyExpiryMode(expiryMode, false)"
											placement="bottom-start">
										</fa-icon>
										<span *ngIf="activation.enabled === 0 && !slt.isSpecialKey(activation)">
											- Key is not enabled</span>
									</span>
								</div>

								<div *ngIf="activation.enabled === 1 && expiryMode && expiryMode === 'meter'" class="cp-property-block">
									<!-- <span class="cp-property-label">Expiry:</span>
								<span class="cp-property-value">See meters</span> -->
									<span *ngIf="mt.hasExpired(keyExpiryCalc)" class="cp-property-label">Expired
										(meter):</span>
									<span *ngIf="!mt.hasExpired(keyExpiryCalc)" class="cp-property-label">Expires
										(meter):</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': mt.hasExpired(keyExpiryCalc)}">
										{{ keyExpiryCalc | date: ac.shortPageDateFmt:'UTC' }}
										- {{ tt.niceExpireText(keyExpiryCalc) }}
									</span>
								</div>

								<div *ngIf="expiryMode && expiryMode === 'date' && activation.expires_at" class="cp-property-block">
									<span *ngIf="mt.hasExpired(activation.expires_at)" class="cp-property-label">Expired:</span>
									<span *ngIf="!mt.hasExpired(activation.expires_at)" class="cp-property-label">Expires:</span>
									<span class="cp-property-value" [ngClass]="{'text-danger': mt.hasExpired(activation.expires_at)}">
										{{ activation.expires_at | date: ac.shortPageDateFmt:'UTC' }}
										- {{ tt.niceExpireText(activation.expires_at) }}
									</span>
								</div>

								<div *ngIf="expiryMode && expiryMode === 'duration' && activation.duration && activation.duration !== 0"
									class="cp-property-block">
									<span class="cp-property-label">
										Duration
										<fa-icon [icon]="['fas', 'question-circle']" ngbTooltip="Lifespan of licenses from date of issue"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">{{
										slt.niceKeyDuration(activation.duration)
										}}</span>
								</div>

								<div class="cp-property-block" *ngIf="showMeters && activation.first_meter_report">
									<span class="cp-property-label">
										Meter Reporting
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in against a meter"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_meter_report | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_meter_report | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="showMeters && activation.first_meter_usage">
									<span class="cp-property-label">
										Meter Usage
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in non-zero traffic against a meter"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_meter_usage | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_meter_usage | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="protocolReady && activation.first_protocol_report">
									<span class="cp-property-label">
										Protocol Reporting
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in protocol traffic"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_protocol_report | date: ac.shortPageDateFmt:'UTC' }}
										to
										{{ activation.last_protocol_report | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>

								<div class="cp-property-block" *ngIf="protocolReady && activation.first_protocol_usage">
									<span class="cp-property-label">
										Protocol Usage
										<fa-icon [icon]="['fas', 'question-circle']"
											ngbTooltip="Timeframe this key has activations reporting in non-zero protocol traffic"
											placement="bottom-start">
										</fa-icon> :
									</span>
									<span class="cp-property-value">
										{{ activation.first_protocol_usage | date: ac.shortPageDateFmt:'UTC' }} to
										{{ activation.last_protocol_usage | date: ac.shortPageDateFmt:'UTC' }}
									</span>
								</div>
							</div>

							<div *ngIf="registeredKey && userKey && (userKey.is_deleted === 0 || keySnoozes.length > 0)" class="m-1 p-1">
								<button *ngIf="registeredKey && userKey && userKey.is_deleted === 0" type="button"
									class="btn btn-outline-primary btn-sm ms-1" (click)="editKeySnooze(0)"
									ngbTooltip="You can stop receiving notifications about this key for a specified period of time"
									placement="bottom-end">
									<fa-icon [icon]="['fas', 'snooze']"></fa-icon>
									<span class="cp-action-button-text">Snooze/Pause Notifications</span>
								</button>

								<div *ngIf="keySnoozes.length > 0" class="mt-1">
									Current Snoozes/Pauses for this Key

									<table *ngIf="keySnoozes.length > 0" class="table table-striped table-hover cp-auto-width">
										<thead>
											<tr>
												<th>Type</th>
												<th>Resume Notifications On</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let snooze of keySnoozes">
												<td class="cp-110">
													{{ mt.fetchLabel(ac.keySnoozeTypes, snooze.snooze_type) }}
												</td>
												<td class="cp-110">
													{{ snooze.expires_at | date: ac.shortPageDateFmt:'UTC' }}
													({{ tt.niceDaysText(snooze.expires_at) }}) </td>
												<td class="cp-icon-cell">
													<button type="button" class="btn btn-outline-primary btn-sm"
														(click)="editKeySnooze(snooze.id)"
														ngbTooltip="Update the type or expiration of this snooze/pause">
														<fa-icon icon="pencil"></fa-icon>
													</button>
													<button type="button" class="btn btn-outline-danger btn-sm"
														(click)="deleteSnooze(snooze)" ngbTooltip="Cancel this snooze/pause">
														<fa-icon icon="trash-alt"></fa-icon>
													</button>
												</td>
											</tr>
										</tbody>
									</table>


									<!-- <div *ngFor="let snooze of keySnoozes" class="pt-2">
										<div class="btn-group mb-1">
											<button type="button" class="btn btn-outline-primary btn-sm" (click)="editKeySnooze(snooze.id)"
												ngbTooltip="Update the type or expiration of this snooze/pause">
												<fa-icon icon="pencil"></fa-icon>
											</button>
											<button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteSnooze(snooze)"
												ngbTooltip="Cancel this snooze/pause">
												<fa-icon icon="trash-alt"></fa-icon>
											</button>
										</div>

										<div class="cp-property-block">
											<span class="cp-property-label">Type:</span>
											<span class="cp-property-value">
												{{ mt.fetchLabel(ac.keySnoozeTypes, snooze.snooze_type) }}
											</span>
										</div>

										<div class="cp-property-block">
											<span class="cp-property-label">Resume Notifications On:</span>
											<span class="cp-property-value">
												{{ snooze.expires_at | date: ac.shortPageDateFmt:'UTC' }}
												({{ tt.niceDaysText(snooze.expires_at) }})
											</span>
										</div>
									</div> -->
								</div>
							</div>

						</div>

						<div class="col-6 px-0">
							<div *ngIf="activation.ext_notes && activation.ext_notes.trim() !== ''"
								class="bg-light border m-1 p-1 overflow-auto" style="max-height: 480px">
								<div class="cp-property-block">
									<span class="cp-property-label">Notes:</span>
									<div class="cp-property-value cp-pre-text">
										{{ activation.ext_notes.trim() }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>



			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-commercial"
				aria-labelledby="nav-commercial-tab">

				<div *ngIf="staffMode && !!activation && (meterWarnings.length !== 0 || nonEnforcedWarnings.length !== 0)"
					class="cp-warning-message mb-2">
					<div *ngFor="let item of meterWarnings">
						<fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
						{{ item }}
					</div>
				</div>

				<div class="cp-info-message mb-2" *ngIf="canManageCommercial && !commercialTypeInfo && commercialGuesses != null &&
				commercialGuesses.commericialGuesses.length === 1">
					Based on this key's properties, the commercial type is likely:<br />
					<span class="fw-bold">
						{{ getCommercialTypeLabel(commercialGuesses.commericialGuesses[0]) }}
					</span><br />
					The reason is:<br />
					<span class="fw-bold">
						{{ commercialGuesses.commericialExtras }}
					</span><br />
					<button type="button" class="btn btn-outline-primary btn-sm mb-1"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'commercial', commercialGuesses.commericialGuesses[0]]">
						Use this Recommendation
					</button>
				</div>

				<button *ngIf="activation && actionsReady && canManageCommercial" type="button" class="btn btn-outline-primary btn-sm mb-1"
					[routerLink]="['/' + ac.urls.licensing, activation.id, 'commercial']">
					<fa-icon icon="pencil"></fa-icon>
					Set/Update Commercial Information
				</button>

				<div *ngIf="activation" class="cp-property-list">
					<div class="cp-property-block">
						<span class="cp-property-label">Commercial Type:</span>
						<span *ngIf="!commercialTypeInfo" class="cp-property-value">Not Set</span>
						<span *ngIf="commercialTypeInfo" class="cp-property-value">
							{{ commercialTypeInfo.label }}<br />
						</span>
						<div *ngIf="commercialTypeInfo">
							<ul>
								<li *ngFor="let line of commercialTypeInfo.info.trim().split('\n')"
									[ngClass]="{ 'ms-4': line.startsWith('\t') }">
									{{ line }}
								</li>
							</ul>
						</div>
					</div>

					<div class="cp-property-block">
						<span class="cp-property-label">Commercial Notes:</span>
						<div *ngIf="activation.commercial_info" class="cp-property-value cp-pre-text">{{ activation.commercial_info }}</div>
						<div *ngIf="!activation.commercial_info" class="cp-property-value fst-italic">No notes</div>
					</div>

					<div *ngIf="linkedProtocolSets.length > 0" class="border-top mt-1 pt-1">
						This key is linked to <span class="fw-bold">{{ linkedProtocolSets.length }} protocol set{{ linkedProtocolSets.length
							!==
							1 ? 's' : '' }}</span>. See the <span class="fw-bold">{{ metersTabLabel }}</span> tab for details.
					</div>
				</div>
			</div>

			<div *ngIf="pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-features" aria-labelledby="nav-features-tab">
				<app-key-features #keyFeatures></app-key-features>
			</div>

			<div *ngIf="pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-activations"
				aria-labelledby="nav-activations-tab">
				<div *ngIf="!loading && activation && activation.licenses.length === 0" class="cp-light-message mb-1">
					This key does not have any activated licenses.
				</div>

				<div *ngIf="activation && activation.discard_licenses === 1" class="cp-light-message mb-1">
					Activated licenses for this key are deleted after {{ ac.maxStaleLicenseDays }} days if they no
					longer appear to be in use.
				</div>

				<div *ngIf="showMaxHostsExtra" class="cp-warning-message mb-1">
					Limited to showing {{ ac.maxLicenseRowsToFetch | number }} recent activations.
					<span *ngIf="fullLicenseCount !== 0">There's a total of {{ fullLicenseCount | number }} licenses in the
						database for this key.</span>
					<span *ngIf="activeLicenses.length > 0">Use the Active tab to find active licenses or use Search tab to
						find a specific license.</span>
					<span *ngIf="activeLicenses.length === 0">Use the Search tab to find a specific license.</span>
				</div>

				<button *ngIf="showDownloadRecentButton" type="button" class="btn btn-outline-secondary btn-sm mb-2 me-1"
					(click)="getNewLicenses()" ngbTooltip="Download Zip file with licenses issued over the last couple of days.">
					<fa-icon icon="file-archive"></fa-icon>
					Download New Licenses
				</button>

				<button *ngIf="activation && activation.licenses.length !== 0" type="button"
					class="btn btn-outline-secondary btn-sm mb-2 me-1" (click)="runLicenseReport()"
					ngbTooltip="Create a spreadsheet with information about all licenses issued from this key.">
					<fa-icon icon="file-excel"></fa-icon>
					Generate License Report
				</button>

				<button *ngIf="usageSummaryForm && activation && activation.licenses.length !== 0" type="button"
					class="btn btn-outline-secondary btn-sm mb-2 me-1" data-bs-toggle="modal" data-bs-target="#usage-summary-modal"
					ngbTooltip="Create a spreadsheet with a usage breakdown by month and for each activated host ID and by meter type and/or total protocol usage">
					<fa-icon icon="file-excel"></fa-icon>
					Generate Usage Summary Report By Host ID
				</button>

				<button *ngIf="registeredKey && activation && activation.licenses && activation.licenses.length !== 0" type="button"
					class="btn btn-outline-primary btn-sm mb-2 me-1" (click)="setHostIdLabels()">
					<fa-icon [icon]="ac.actionIcons.edit"></fa-icon>
					Set Labels for Host IDs
				</button>

				<app-table-licenses #allLicensesTable></app-table-licenses>
			</div>

			<div *ngIf="pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-active" aria-labelledby="nav-active-tab">
				<div class="cp-light-message mb-1">
					Below are systems that have reported in the last {{ ac.maxActiveLicenseDays }} days.
				</div>
				<app-table-licenses #activeLicensesTable></app-table-licenses>
			</div>

			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-pen-test"
				aria-labelledby="nav-pen-test-tab">
				<table *ngIf="failedPenTests && failedPenTests.length !== 0" class="cp-std-table cp-auto-width">
					<thead>
						<tr>
							<th class="border-start">Host ID</th>
							<th class="border-start">IP</th>
							<th class="border-start">User</th>
							<th class="border-start">First Check</th>
							<th class="border-start">Latest Check</th>
							<th class="border-start">Details</th>
							<th class="border-start"></th>
							<th class="border-start"></th>
							<th class="border-start"></th>
						</tr>
					</thead>

					<tbody>
						<tr *ngFor="let p of failedPenTests" class="cp-pointer">
							<td class="border-start text-nowrap cp-key">
								<a [routerLink]="['/' + ac.urls.licensing, 'hostid', p.hostid, activation.id]">
									{{ p.hostid }}</a>
							</td>
							<td class="border-start text-nowrap">
								<a [routerLink]="['/' + ac.urls.licensing, 'ip', p.ip]">
									{{ p.ip }}
								</a>
							</td>
							<td class="border-start text-nowrap">
								{{ p.username }}
							</td>
							<td class="border-start text-nowrap">
								{{ p.added_on | date: ac.tableDateTimeFmt }}
							</td>
							<td class="border-start text-nowrap">
								{{ p.last_checked_on | date: ac.tableDateTimeFmt }}
							</td>
							<td class="border-start">
								{{ p.test_msg }}
							</td>
							<td class="border-start text-nowrap">
								<button type="button" class="btn btn-outline-primary btn-sm" (click)="runPenTestOnIPs([p.ip], p.username)"
									[disabled]="penTestRunning">
									<fa-icon [icon]="['fas', 'bolt']" [spin]="penTestRunning"></fa-icon>
									Re-run Pen Test
								</button>
							</td>
							<td class="border-start text-nowrap">
								<a [href]="'http://' + p.ip + ':4444/'" target="_blank" class="ms-1" ngbTooltip="Login Page">
									<fa-icon [icon]="['fas', 'sign-in-alt']"></fa-icon>
								</a>
							</td>
							<td class="border-start text-nowrap">
								<a [href]="'https://ipinfo.io/' + p.ip" target="_blank" class="ms-1" ngbTooltip="IP Info">
									<fa-icon [icon]="['fas', 'external-link-square-alt']"></fa-icon>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-users"
				aria-labelledby="nav-users-tab">
				<div *ngIf="!loading && userKeys && userKeys.length === 0" class="cp-light-message">
					This key has not been registered by/shared with any users.
				</div>

				<div *ngIf="!loading && userKeys && userKeys.length > 0" class="cp-light-message">
					This key has been registered by/shared with the following users.
				</div>

				<table *ngIf="userKeys && userKeys.length !== 0" class="cp-std-table cp-auto-width">
					<thead>
						<tr>
							<th class="border-start">Name</th>
							<th class="border-start">E-Mail</th>
							<th class="border-start">Organization</th>
							<th class="border-start">Label</th>
							<th class="border-start">Protocol Usage</th>
							<th class="border-start">Key Related Notifications</th>
							<th class="border-start cp-icon-header">
								<fa-icon [icon]="['fas', 'snooze']" placement="start" ngbTooltip="Snoozed/Paused Notifications">
								</fa-icon>
							</th>
							<th class="border-start"></th>
						</tr>
					</thead>

					<tbody>
						<tr *ngFor="let item of userKeys" [routerLink]="['/' + ac.urls.users, item.user.id]" class="cp-pointer">
							<!-- <td class="text-nowrap">{{ item.created_at }}</td> -->
							<td class="border-start text-nowrap">
								<a [routerLink]="['/' + ac.urls.users, item.user.id]" [ngbPopover]="userPopupContent"
									popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
									{{ item.user.name }}</a>
							</td>
							<td class="border-start text-nowrap">{{ item.user.email }}</td>
							<td class="border-start text-nowrap">{{ item.user.org_name }}</td>
							<td class="border-start">
								<span *ngIf="!item.label || item.label === ''" class="font-italic"
									title="This User has not set a label for this key">
									Not Set
								</span>
								<span *ngIf="item.label && item.label !== ''">
									{{ item.label }}
								</span>
							</td>
							<td class="border-start">
								<span ngbTooltip="This user is able to see protocol usage in the portal.">
									Yes
								</span>

								<!-- <span *ngIf="tt.getUserPropValue(item.user, ac.showBxProtocolStatsOverride) === 'yes'"
								ngbTooltip="This user is able to see protocol usage in the portal.">
								Yes
							</span>
							<span *ngIf="tt.getUserPropValue(item.user, ac.showBxProtocolStatsOverride) !== 'yes'"
								ngbTooltip="This user is NOT able to see protocol usage in the portal.">
								No
							</span> -->
							</td>
							<td class="border-start cp-pre-text" [innerHTML]="slt.makeUserNotificationSummary(item.user)"></td>
							<td class="border-start cp-icon-cell"
								[attr.data-order]="userSnoozes[item.user_id] ? userSnoozes[item.user_id].length : 0">
								<fa-icon *ngIf="userSnoozes[item.user_id] && userSnoozes[item.user_id].length > 0"
									[icon]="['fas', 'snooze']" placement="start" [ngbTooltip]="makeSnoozeTooltip(item.user_id)">
								</fa-icon>
							</td>
							<td class="border-start">
								<fa-icon *ngIf="item.is_deleted === 1" [icon]="['fas', 'trash-alt']"
									ngbTooltip="The user has placed this key in the trash" placement="bottom-end">
								</fa-icon>
							</td>

							<ng-template #userPopupContent>
								<app-card-user [object]="item.user"></app-card-user>
							</ng-template>
						</tr>
					</tbody>
				</table>

				<div *ngIf="organization && otherOrgUsers.length > 0">
					Share Key with <span *ngIf="userKeys && userKeys.length !== 0">other</span>
					users from {{ organizationForUsers.name }}:
					<fa-icon [icon]="['fas', 'question-circle']"
						ngbTooltip="The following users are part of the same organization as this key (or from its parent organization) and the key has not been shared with them.">
					</fa-icon>

					<div *ngFor="let u of otherOrgUsers" class="mt-1 ms-2">
						<button type="button" class="btn btn-outline-info btn-sm" (click)="shareKeyWithUser(u)"
							ngbTooltip="Share key with this user so they can view information about it" [disabled]="loading">
							<fa-icon [icon]="['fas', 'plus']"></fa-icon>
						</button>
						<a [routerLink]="['/' + ac.urls.users, u.id  ]" [ngbPopover]="userPopupContent" popoverClass="cp-popover-std"
							triggers="mouseenter:mouseleave" container="body">
							{{ u.name }}
						</a> ({{ u.email }})
						<ng-template #userPopupContent>
							<app-card-user [object]="u"></app-card-user>
						</ng-template>
					</div>
				</div>
			</div>

			<div *ngIf="pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-search" aria-labelledby="nav-search-tab">
				<form *ngIf="searchForm" [formGroup]="searchForm" class="ms-4">
					<div class="row">
						<div class="form-group">
							<div class="input-group">
								<input type="text" id="hostidFilter" formControlName="hostidFilter" class="form-control"
									placeholder="Host ID(s)/IP(s)" />
								<button class="btn btn-primary btn-sm" type="button" (click)="doSearch()">
									<fa-icon [icon]="['fas', 'search']"></fa-icon> Search
								</button>
							</div>
						</div>
					</div>
				</form>

				<div [ngStyle]="{'display': !showSearchResults ? 'none' : '' }">
					<app-table-licenses #searchLicensesTable></app-table-licenses>
				</div>
			</div>

			<div *ngIf="!staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-shares"
				aria-labelledby="nav-shares-tab">
				<div class="ms-2">You shared this key with the following users:</div>
				<ul>
					<li *ngFor="let item of sharedWithUsers">{{ item.name }}</li>
				</ul>
			</div>

			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-admin-log"
				aria-labelledby="nav-admin-log-tab">
				<div *ngIf="!loading && adminLogs.length === 0" class="cp-light-message">
					No system/change Logs for this License Key.
				</div>

				<app-table-logs #logsTable1 [expandNames]="true"></app-table-logs>
			</div>

			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-journal"
				aria-labelledby="nav-journal-tab">
				<div *ngIf="!loading && (!journals || journals.length === 0)" class="cp-light-message">
					No journal entries for this License Key.
				</div>

				<button *ngIf="canAddJournals" type="button" class="btn btn-outline-primary btn-sm mb-2 me-1"
					[routerLink]="['/' + ac.urls.adminlogs, 'journal', 'activation', activation.id]">
					<fa-icon [icon]="ac.sectionIcons.journals"></fa-icon> Add Journal Entry
				</button>

				<div *ngFor="let item of journals" class="cp-property-list">
					<div *ngIf="canDeleteJournalEntry(item)" class="float-end">
						<fa-icon [icon]="['fas', 'trash-alt']" class="text-danger" placement="start" ngbTooltip="Delete this journal entry"
							(click)="deleteJournalEntry(item)"></fa-icon>
					</div>
					<div class="fw-bold">
						{{ item.added_on | date: ac.shortPageDateTimeFmt }} by {{ getUsersName(item.added_by) }}
					</div>
					<div class="cp-pre-text">{{ item.information.trim() }}</div>
				</div>
			</div>

			<div *ngIf="staffMode && pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-marketplace-log"
				aria-labelledby="nav-marketplace-log-tab">
				<div *ngIf="!loading && marketplaceLogs.length === 0" class="cp-light-message">
					No marketplace logs for this key.
				</div>

				<app-table-marketplace-logs></app-table-marketplace-logs>
			</div>

			<!-- hostid tab panels -->

			<div *ngIf="['hostid', 'ip'].includes(pageMode)" class="tab-pane show active" role="tabpanel" id="nav-activation-details"
				aria-labelledby="nav-activation-details-tab">

				<div class="cp-width-limit-1400">
					<div *ngIf="staffMode && filterID !== 0 && filterKey !== '' && activationIDsForObject.length > 1"
						class="cp-info-message mb-1">
						Showing activations for <span class="fw-bold">{{ hostid }}</span> using <span class="fw-bold">{{
							filterKey }}</span>
						<div>There are activations from {{ (activationIDsForObject.length - 1) }} other key(s).</div>
						<button (click)="filterTraffic(0)" type="button" class="btn btn-sm btn-outline-primary"
							ngbTooltip="Remove filter and show all usage" placement="start">
							<fa-icon icon="times-circle"></fa-icon>
							Show All Activations
						</button>
					</div>

					<div class="cp-general-width-limit">
						<div *ngIf="!staffMode" class="border p-2 mb-1">
							<div class="cp-property-block">
								<span class="cp-property-label">Label:</span>
								<span *ngIf="label && label !== ''" class="cp-property-value">{{ label }}</span>
								<span *ngIf="!label || label === ''" class="cp-property-value font-italic">
									Not Set</span>
							</div>
						</div>

						<div *ngFor="let item of licenses; let i = index" class="border p-2 mb-1"
							[hidden]="filterID !== 0 && filterID !== item.activation_id">
							<span class="text-end" style="float:right">
								<button (click)="showLicenseFeatures(item.id)" type="button" class="btn btn-sm btn-outline-primary me-1"
									ngbTooltip="Show features/limits set with this license" placement="start">
									<fa-icon [icon]="['fas', 'clipboard-list-check']" [fixedWidth]="true">
									</fa-icon>
									Features+Limits
								</button>

								<button *ngIf="staffMode && item.fulfillment && item.fulfillment !== ''"
									(click)="downloadLicenseFiles(item.id)" type="button" class="btn btn-outline-primary btn-sm me-1"
									ngbTooltip="Download the license file from this activation with standard name" placement="start">
									<fa-icon [icon]="['fas', 'cloud-download-alt']" [fixedWidth]="true"></fa-icon>
									<sup>1</sup>
								</button>

								<button *ngIf="staffMode && item.fulfillment && item.fulfillment !== ''"
									(click)="downloadLicenseFiles(item.id, true)" type="button" class="btn btn-outline-primary btn-sm me-1"
									ngbTooltip="Download the license file from this activation with filename that includes host ID"
									placement="start">
									<fa-icon [icon]="['fas', 'cloud-download-alt']" [fixedWidth]="true"></fa-icon>
									<sup>2</sup>
								</button>
							</span>

							<button *ngIf="staffMode && linkOfflineForm && showLinkOfflineLicense && item.id === latestID" type="button"
								class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#link-offline-modal">
								<fa-icon icon="link"></fa-icon>
								Link to an Offline Key
							</button>

							<div *ngIf="staffMode && hostKeys[item.id]" class="cp-property-block">
								<span class="cp-property-label">Key:</span>
								<span class="cp-property-value cp-key">
									<a [routerLink]="['/' + ac.urls.licensing, 'activation', item.activation_id]"
										[ngbPopover]="keyPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
										container="body">{{ hostKeys[item.id].key
										}}</a>
									<button
										*ngIf="!loading && filterID === 0 && item.activation_id && item.activation_id !== 0 && activationIDsWithUsage.length > 1"
										(click)="filterTraffic(item.activation_id)" type="button"
										class="btn btn-sm ms-1 btn-outline-primary"
										ngbTooltip="Filter usage to only show traffic using this key" placement="start">
										<fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
									</button>
								</span>
								<ng-template #keyPopupContent>
									<app-card-key [object]="hostKeys[item.id]" [keyProducts]="keyProducts" [organizations]="allOrgs"
										[users]="staffUsers" [forBasic]="false"></app-card-key>
								</ng-template>
							</div>

							<div *ngIf="staffMode &&  !hostKeys[item.id]" class="cp-property-block">
								<span class="cp-property-label">Key:</span>
								<span class="cp-property-value">No Key - Offline License
								</span>
							</div>

							<div *ngIf="staffMode && hostKeys[item.id] && hostKeys[item.id].zcp_org_id && hostKeys[item.id].zcp_org_id !== 0 && hostKeys[item.id].org_name && hostKeys[item.id].org_name !== ''"
								class="cp-property-block">
								<span class="cp-property-label">Organization:</span>
								<span class="cp-property-value">
									<a [routerLink]="['/' + ac.urls.organizations, hostKeys[item.id].zcp_org_id ]">
										{{ hostKeys[item.id].org_name }}
									</a>
								</span>
							</div>

							<div *ngIf="pageMode === 'ip'" class="cp-property-block">
								<span class="cp-property-label">
									Host ID:
								</span>
								<span class="cp-property-value">
									<a [routerLink]="['/' + ac.urls.licensing, 'hostid', item.hostid, item.activation_id]">
										{{ item.hostid }}
									</a>
								</span>
							</div>

							<div class="cp-property-block">
								<span class="cp-property-label">Issued:</span>
								<span class="cp-property-value">
									{{ item.created_at | date: ac.shortPageDateTimeFmt }}
								</span>
							</div>

							<div *ngIf="item.updated_at" class="cp-property-block">
								<span class="cp-property-label">Updated:</span>
								<span class="cp-property-value">
									{{ item.updated_at | date: ac.shortPageDateTimeFmt }}
								</span>
							</div>

							<div *ngIf="!item.expires_at" class="cp-property-block">
								<span class="cp-property-label">Expires:</span>
								<span class="cp-property-value">Never - Permanent License</span>
							</div>

							<div *ngIf="item.expires_at" class="cp-property-block">
								<span *ngIf="mt.hasExpired(item.expires_at)" class="cp-property-label">Expired:</span>
								<span *ngIf="!mt.hasExpired(item.expires_at)" class="cp-property-label">
									Expires
									<fa-icon *ngIf="expiryExtraActivation[item.id] && expiryExtraActivation[item.id] !== ''"
										[icon]="['fas', 'question-circle']" [ngbTooltip]="expiryExtraActivation[item.id]"
										placement="bottom-start"></fa-icon>
									:
								</span>
								<span class="cp-property-value">
									{{ item.expires_at | date: ac.shortPageDateTimeFmt }}
								</span>
							</div>

							<div *ngIf="staffMode && item.customer" class="cp-property-block">
								<span class="cp-property-label">Customer:</span>
								<span class="cp-property-value">{{ item.customer }}</span>
							</div>

							<div class="cp-property-block">
								<span class="cp-property-label">Product:</span>
								<span class="cp-property-value" [title]="item.product">
									{{ niceKeyProduct(item.product) }}
								</span>
							</div>

							<div *ngIf="staffMode" class="cp-property-block">
								<span class="cp-property-label">Type:</span>
								<span class="cp-property-value">{{ item.type | titlecase }}</span>
							</div>

							<div *ngIf="pageMode === 'hostid' && item.ip && item.ip !== ''" class="cp-property-block">
								<span class="cp-property-label">
									IP
									<fa-icon [icon]="['fas', 'question-circle']" placement="end" [ngbTooltip]="ac.hostIDIPNote">
									</fa-icon>
									:
								</span>
								<span *ngIf="staffMode" class="cp-property-value">
									<a [routerLink]="['/' + ac.urls.licensing, 'ip', item.ip]">
										{{ item.ip }}
									</a>
									&nbsp;<fa-icon [icon]="['fas', 'copy']" ngxClipboard (click)="copyToClipboardAlert(item.ip)"
										[cbContent]="item.ip" ngbTooltip="Copy to Clipboard"></fa-icon>
								</span>
								<span *ngIf="!staffMode" class="cp-property-value" ngxClipboard (click)="copyToClipboardAlert(item.ip)"
									[cbContent]="item.ip" ngbTooltip="Copy to Clipboard">
									{{ item.ip }}
									&nbsp;<fa-icon [icon]="['fas', 'copy']" n></fa-icon>
								</span>

								<a [href]="'https://ipinfo.io/' + item.ip" target="_blank" class="ms-1" ngbTooltip="IP Info">
									<fa-icon [icon]="['fas', 'external-link-square-alt']"></fa-icon>
								</a>
							</div>

							<div *ngIf="pageMode === 'ip'" class="cp-property-block">
								<span class="cp-property-label">
									IP
									<fa-icon [icon]="['fas', 'question-circle']" placement="end" [ngbTooltip]="ac.hostIDIPNote">
									</fa-icon>
									:
								</span>
								<span class="cp-property-value">
									{{ ip }}
								</span>
								<a [href]="'https://ipinfo.io/' + ip" target="_blank" class="ms-1" ngbTooltip="IP Info">
									<fa-icon [icon]="['fas', 'external-link-square-alt']"></fa-icon>
								</a>
							</div>

							<div *ngIf="item.extraProperties" class="cp-property-block">
								<span class="cp-property-label">
									Extra Properties:
								</span>
								<div class="cp-property-value cp-pre-text cp-75 ms-2">
									{{ slt.niceLicenseExtraProperties(item.extraProperties) }}
								</div>
							</div>

							<div *ngIf="staffMode && meterTypesPerActivation[item.id] && meterTypesPerActivation[item.id] !== ''"
								class="cp-property-block">
								<span class="cp-property-label">
									Meter Types (key):
								</span>
								<span class="cp-property-value">
									{{ meterTypesPerActivation[item.id] }}
								</span>
							</div>

							<div *ngIf="staffMode && licenseMeterNames[item.id] && licenseMeterNames[item.id] !== ''"
								class="cp-property-block">
								<span class="cp-property-label">
									Meter Types (license):
								</span>
								<span class="cp-property-value">
									{{ licenseMeterNames[item.id] }}
								</span>
							</div>


							<div *ngIf="!staffMode && meterTypes.length > 0" class="cp-property-block">
								<span class="cp-property-label">Meter Types:</span>
								<span class="cp-property-value">{{ meterTypes.join(', ') }}</span>
							</div>


							<div *ngIf="licenseFormats[item.id] && licenseFormats[item.id] !== ''" class="cp-property-block">
								<span class="cp-property-label">
									License File Format:
								</span>
								<span class="cp-property-value">
									{{ licenseFormats[item.id] }}
								</span>
							</div>

							<div *ngIf="showMeterTraffic && item.first_meter_report" class="cp-property-block">
								<span class="cp-property-label">
									Meter Reporting
									<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="Timeframe this activation reports in against a meter" placement="top-start">
									</fa-icon> :
								</span>
								<span class="cp-property-value">
									{{ item.first_meter_report | date: ac.shortPageDateFmt:'UTC' }} to
									{{ item.last_meter_report | date: ac.shortPageDateFmt:'UTC' }}
								</span>
							</div>

							<div *ngIf="showMeterTraffic && item.first_meter_usage" class="cp-property-block">
								<span class="cp-property-label">
									Meter Usage
									<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="Timeframe this activation reports in non-zero traffic against a meter"
										placement="top-start">
									</fa-icon> :
								</span>
								<span class="cp-property-value">
									{{ item.first_meter_usage | date: ac.shortPageDateFmt:'UTC' }} to
									{{ item.last_meter_usage | date: ac.shortPageDateFmt:'UTC' }}
								</span>
							</div>

							<div *ngIf="protocolReady && item.first_protocol_report" class="cp-property-block">
								<span class="cp-property-label">
									Protocol Reporting
									<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="Timeframe this activation reports in protocol traffic" placement="top-start">
									</fa-icon> :
								</span>
								<span class="cp-property-value">
									{{ item.first_protocol_report | date: ac.shortPageDateFmt:'UTC' }} to
									{{ item.last_protocol_report | date: ac.shortPageDateFmt:'UTC' }}
								</span>
							</div>

							<div *ngIf="protocolReady && item.first_protocol_usage" class="cp-property-block">
								<span class="cp-property-label">
									Protocol Usage
									<fa-icon [icon]="['fas', 'question-circle']"
										ngbTooltip="Timeframe this activation reports in non-zero protocol traffic" placement="top-start">
									</fa-icon> :
								</span>
								<span class="cp-property-value">
									{{ item.first_protocol_usage | date: ac.shortPageDateFmt:'UTC' }} to
									{{ item.last_protocol_usage | date: ac.shortPageDateFmt:'UTC' }}
								</span>
							</div>

							<div class="cp-property-block" *ngIf="item.last_protocol_bx_version && item.last_protocol_bx_version !== ''">
								<span class="cp-property-label">Last Reported Version:</span>
								<span class="cp-property-value">
									{{ tt.cleanVersion(item.last_protocol_bx_version) }}
								</span>
							</div>

							<div *ngIf="staffMode && item['__penTest']" class="cp-property-block">
								<span class="cp-property-label">
									Pen Test Results:
									<a [href]="'http://' + item.ip + ':4444/'" target="_blank" class="ms-1" ngbTooltip="Login Page">
										<fa-icon [icon]="['fas', 'sign-in-alt']"></fa-icon>
									</a>
								</span>
								<span class="cp-property-value">
									<table class="cp-std-table cp-auto-width">
										<thead>
											<tr class="cp-75">
												<th class="border-start"></th>
												<th class="border-start">User</th>
												<th class="border-start">Latest Check</th>
												<th class="border-start">Details</th>
												<th class="border-start"></th>
											</tr>
										</thead>

										<tbody>
											<tr *ngFor="let p of item['__penTest']" class="cp-75">
												<td class="border-start text-nowrap">
													<fa-icon *ngIf="ac.penTestCodes[p.test_code]" [icon]="ac.penTestCodes[p.test_code].icon"
														[class]="ac.penTestCodes[p.test_code].css">
													</fa-icon>
												</td>
												<td class="border-start text-nowrap">
													{{ p.username }}
												</td>
												<td class="border-start text-nowrap">
													{{ p.last_checked_on | date: ac.tableDateTimeFmt }}
												</td>
												<td class="border-start">
													<span [ngbTooltip]="p.test_msg">
														{{ p.test_msg }}
													</span>
												</td>
												<td class="border-start text-nowrap">
													<button *ngIf="p.test_code === 0 || p.test_code === 3" type="button"
														class="btn btn-outline-primary btn-sm" (click)="runPenTestOnIPs([p.ip], p.username)"
														[disabled]="penTestRunning" ngbTooltip="Re-run Pen Test">
														<fa-icon [icon]="['fas', 'bolt']" [spin]="penTestRunning"></fa-icon>
														Re-run
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="pageMode === 'hostid'" class="tab-pane" role="tabpanel" id="nav-versions" aria-labelledby="nav-versions-tab">
				<div *ngIf="historyLoading" class="cp-info-message border">
					<fa-icon icon="sync-alt" [animation]="'spin'"></fa-icon>
					The version history is being retrieved. This may take a minute.
				</div>

				<table *ngIf="versionHistory.length > 0" class="cp-std-table cp-auto-width">
					<thead>
						<tr>
							<th class='text-start border-start'>Earliest</th>
							<th class='text-start border-start'>Latest</th>
							<th class='text-start border-start'>Version</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let vh of versionHistory">
							<td class="text-start border-start text-nowrap">
								{{ vh.first_reported | date: ac.pageDateFmt:'UTC'}}
							</td>
							<td class="text-start border-start text-nowrap">
								{{ vh.last_reported | date: ac.pageDateFmt:'UTC'}}
							</td>
							<td class="text-start border-start text-nowrap">
								{{ tt.cleanVersion(vh.version) }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="staffMode && pageMode === 'hostid'" class="tab-pane" role="tabpanel" id="nav-host-labels"
				aria-labelledby="nav-host-labels-tab">
				<table class="cp-std-table cp-auto-width">
					<thead>
						<tr>
							<th class='text-start border-start'>User</th>
							<th class='text-start border-start'>Label</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let label of labels">
							<td class="text-nowrap border-start">
								<a [routerLink]="['/' + ac.urls.users, label.user_id]">
									{{ getUsersName(label.user_id) }}</a>
							</td>
							<td class="text-start border-start">
								{{ label.label }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- aggregate tab panels -->

			<div *ngIf="staffMode && pageMode === 'aggregate'" class="tab-pane show active" role="tabpanel" id="nav-aggregate-items"
				aria-labelledby="nav-aggregate-items-tab">

				<form *ngIf="aggregateForm" [formGroup]="aggregateForm" (ngSubmit)="processAggregateItems()">
					<div class="cp-general-width-limit">

						<div class="form-group">
							<label for="zcp_org_id">Type of Query</label>
							<div class="form-check" *ngFor="let item of typesOfQueries; let i = index">
								<input class="form-check-input" type="radio" formControlName="typeOfAggregateQuery"
									name="typeOfAggregateQuery" [id]="'typeOfAggregateQuery_' + i" [value]="item.value" />
								<label class="form-check-label" [for]="'typeOfAggregateQuery_' + i">
									{{ item.label }}
								</label>
							</div>
						</div>

						<div class="form-group">
							<label *ngIf="typeOfAggregateQueryElement.value === 'keys'" for="keysAndHostIds">License Keys</label>
							<label *ngIf="typeOfAggregateQueryElement.value === 'hostids'" for="keysAndHostIds">Host IDs</label>
							<label *ngIf="typeOfAggregateQueryElement.value === 'mix'" for="keysAndHostIds">License Keys and Host
								IDs</label>
							<textarea id="keysAndHostIds" formControlName="keysAndHostIds" class="form-control" rows="8"></textarea>
						</div>

						<div *ngIf="typeOfAggregateQueryElement.value === 'keys'" class="form-group">
							Enter/paste (line separated): license keys
						</div>
						<div *ngIf="typeOfAggregateQueryElement.value === 'hostids'" class="form-group">
							Enter/paste (line separated) either: host IDs
						</div>
						<div *ngIf="typeOfAggregateQueryElement.value === 'mix'" class="form-group">
							Enter/paste (line separated) either: license keys and/or license keys and host IDs separated by
							a colon (:)
						</div>

						<div *ngFor="let resolveProblem of resolveProblems" class="cp-form-error">
							{{ resolveProblem }}
						</div>

						<div class="form-group mb-0" *ngIf="!resolving">
							<button class="btn btn-primary me-1" type="submit" [disabled]="!aggregateForm.valid">
								Get Usage Info
							</button>
						</div>
					</div>
				</form>
			</div>

			<div *ngIf="staffMode && pageMode === 'aggregate'" class="tab-pane" role="tabpanel" id="nav-item-details"
				aria-labelledby="nav-item-details-tab">
				<form *ngIf="aggregateSelectionForm" [formGroup]="aggregateSelectionForm" (ngSubmit)="updateKeysAndHostIds()">

					<button *ngIf="!loading && !resolving" class="btn btn-primary mb-1" type="submit">
						Update Usage Info
					</button>

					<table *ngIf="activationIdAndHostIdsCombos && activationIdAndHostIdsCombos.length > 0"
						class="cp-std-table cp-auto-width">
						<thead>
							<tr>
								<th class="border-start">
									<input type="checkbox" formControlName="select_all" id="select_all" value="yes"
										(change)="checkAllToggle()">
								</th>
								<th class="border-start">Organization</th>
								<th class="border-start">{{ ac.keyInfoFieldLabel }}</th>
								<th class="border-start text-center" title="Key Product">P</th>
								<th class="border-start text-center" title="Key Type">T</th>
								<th class="border-start text-center" title="Key Type">
									<fa-icon [icon]="['fas', 'sack-dollar']" ngbTooltip="Commercial Type"></fa-icon>
								</th>
								<th class="border-start">Key</th>
								<th *ngIf="typeOfAggregateQueryElement.value === 'hostids'" class="border-start">Host ID</th>
							</tr>
						</thead>

						<tbody>
							<tr *ngFor="let activationIdAndHostIdsCombo of activationIdAndHostIdsCombos; let i = index">
								<td class="border-start">
									<input type="checkbox" [formControlName]="'select_' + i" [id]="'select_' + i" value="yes">
								</td>
								<td class="border-start">
									<label [for]="'select_' + i">
										{{
										getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'],
										'organization')
										}}
									</label>
								</td>
								<td class="border-start">
									{{ getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'], 'info') }}
								</td>
								<td class="border-start text-nowrap">
									{{ getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'], 'product')
									}}
								</td>
								<td class="border-start text-nowrap">
									{{ getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'], 'type') }}
								</td>

								<td class="border-start text-nowrap">
									{{ getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'], 'commercial_type') }}
								</td>

								<td class="border-start text-nowrap">
									<a [routerLink]="['/' + ac.urls.licensing, 'activation', activationIdAndHostIdsCombo['activation_id']]"
										[ngbPopover]="popupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
										container="body">
										{{ getFieldFromResolveData(activationIdAndHostIdsCombo['activation_id'], 'key')
										}}
									</a>
								</td>
								<td *ngIf="typeOfAggregateQueryElement.value === 'hostids'" class="border-start text-nowrap">
									<a
										[routerLink]="['/' + ac.urls.licensing, 'hostid', activationIdAndHostIdsCombo['hostid'], activationIdAndHostIdsCombo['activation_id']]">
										{{ activationIdAndHostIdsCombo['hostid'] }}
									</a>
								</td>

								<ng-template #popupContent>
									<app-card-key [object]="getActivationFromResolveData(+activationIdAndHostIdsCombo['activation_id'])"
										[keyProducts]="keyProducts" [organizations]="allOrgs" [users]="staffUsers"
										[forBasic]="false"></app-card-key>
								</ng-template>
							</tr>
						</tbody>
					</table>
				</form>
			</div>

			<div *ngIf="['activation', 'hostid'].includes(pageMode)" class="tab-pane" role="tabpanel" id="nav-bc-summary"
				aria-labelledby="nav-bc-summary-tab">

				<div *ngIf="lotsOfBillingCodes" class="my-2 cp-85 cp-wider-width-limit">
					Because of the large ({{ usedProtocolBillingCodes.length | number }}) number of billing codes used with this key, the
					billing code summary is only available via the "Billing Code Summary Report" button.
				</div>

				<button type="button" class="btn btn-sm btn-outline-info" (click)="runBillingCodeSummaryReport()">
					<fa-icon icon="file-excel"></fa-icon>
					Billing Code Summary Report
				</button>

				<div *ngIf="invalidBillingCodeEntries.length > 0" class="mb-2">
					Invalid Billing Code Use (authentication code is incorrect)

					<table class="cp-std-table cp-auto-width">
						<thead>
							<tr>
								<th class='text-start border-start'>Host ID</th>
								<th class='text-start border-start'>Billing Code</th>
								<th class='text-start border-start'>
									Total Traffic
									<span *ngIf="showRawData">(MB)</span>
								</th>
								<th class='text-start border-start'>Earliest Invalid Use</th>
								<th class='text-start border-start'>Latest Invalid Use</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of invalidBillingCodeEntries">
								<td class="text-start border-start text-nowrap cp-key">
									<a *ngIf="hostid !== item.hostid"
										[routerLink]="['/' + ac.urls.licensing, 'hostid', item.hostid, activation.id]">
										{{ item.hostid }}
									</a>
									<span *ngIf="hostid === item.hostid">
										{{ item.hostid }}
									</span>
								</td>
								<td class="text-start border-start text-nowrap" [ngbPopover]="bcPopupContent" popoverClass="cp-popover-std"
									triggers="mouseenter:mouseleave" container="body">
									{{ item.billing_code }}
								</td>
								<td class="text-end border-start text-nowrap">
									{{ showDataValue(item.total_used) }}
								</td>
								<td class="text-start border-start text-nowrap">
									{{ item.min_day | date: ac.pageDateFmt:'UTC'}}
								</td>
								<td class="text-start border-start text-nowrap"
									[ngClass]="mt.daysSince(item.max_day) < 2 ?'text-danger':''">
									{{ item.max_day | date: ac.pageDateFmt:'UTC'}}
									<fa-icon *ngIf="item['_active']" [icon]="['fas', 'bolt']"
										ngbTooltip="This Host ID appears still be using this billing code with an invalid auth code"></fa-icon>
								</td>
								<ng-template #bcPopupContent>
									<app-card-billing-code [object]="billingCodesByCode[item.billing_code]"></app-card-billing-code>

									<!-- <div class="cp-popover-banner">{{ item.billing_code }}</div>
								<div class="cp-pre-text">{{
									popOverTools.getBillingCodePopoverLines(billingCodesByCode[item.billing_code]).join('\n')}}
								</div> -->
								</ng-template>
							</tr>
						</tbody>
					</table>
				</div>
				<div *ngIf="bcSummaryByHostId.length > 0" class="mb-2">
					Breakdown of Billing Code Use by Host ID
					<table class="cp-std-table cp-auto-width">
						<thead>
							<tr>
								<th class='text-start border-start'>Host ID</th>
								<th class='text-start border-start'>Billing Code</th>
								<th class='text-start border-start'>
									Total Traffic
									<span *ngIf="showRawData">(MB)</span>
								</th>
								<th class='text-start border-start'>Earliest</th>
								<th class='text-start border-start'>Latest</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let bcSummary of bcSummaryByHostId">
								<td class="text-start border-start text-nowrap cp-key">
									<a [routerLink]="['/' + ac.urls.licensing, 'hostid', bcSummary.hostid, activation.id]">
										{{ bcSummary.hostid }}</a>
								</td>
								<td class="text-start border-start text-nowrap" [ngbPopover]="bcPopupContent" popoverClass="cp-popover-std"
									triggers="mouseenter:mouseleave" container="body">
									{{ bcSummary.billing_code }}
								</td>
								<td class="text-end border-start text-nowrap">
									{{ showDataValue(bcSummary.total) }}
								</td>
								<td class="text-start border-start text-nowrap">
									{{ bcSummary.earliest | date: ac.pageDateFmt:'UTC'}}
								</td>
								<td class="text-start border-start text-nowrap">
									{{ bcSummary.latest | date: ac.pageDateFmt:'UTC'}}
								</td>
								<ng-template #bcPopupContent>
									<app-card-billing-code [object]="billingCodesByCode[bcSummary.billing_code]"></app-card-billing-code>

									<!-- <div class="cp-popover-banner">{{ bcSummary.billing_code }}</div>
								<div class="cp-pre-text">{{
									popOverTools.getBillingCodePopoverLines(billingCodesByCode[bcSummary.billing_code]).join('\n')}}
								</div> -->
								</ng-template>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- stuff after this point should be identical between the staff and non-staff versions of this page -->
			<div *ngIf="pageMode === 'activation'" class="tab-pane" role="tabpanel" id="nav-meters" aria-labelledby="nav-meters-tab">
				<app-key-meters [showRawData]="showRawData" [showMeters]="showMeters"
					[canManageCommercial]="canManageCommercial"></app-key-meters>
			</div>

			<div class="tab-pane" role="tabpanel" id="nav-meter-traffic" aria-labelledby="nav-meter-traffic-tab">
				<div *ngIf="meterProductsToShow.length > 0">
					<div *ngIf="filterID !== 0 && activationIDsWithUsage.length > 1">
						Showing usage for <span class="fw-bold">{{ hostid }}</span> using <span class="fw-bold">{{ filterKey
							}}</span>
						<!-- <span *ngIf="activationIDsWithUsage.length > 1" (click)="filterTraffic(0)" class="ms-1"
						ngbTooltip="Remove filter and show all usage">
						<fa-icon icon="times-circle"></fa-icon>
					</span> -->
					</div>
					<div class="mb-1 text-start">
						<div>
							<button *ngIf="showMeterTraffic" type="button" class="btn btn-outline-secondary btn-sm me-1"
								(click)="openUsageReport('meter-data')" placement="bottom-start"
								ngbTooltip="Get a spreadsheet with all monthly and daily meter usage data">
								<fa-icon icon="file-excel"></fa-icon>
								Detailed Meter Traffic Report
							</button>

							<div class="btn-group me-1" *ngIf="chunkedMeterUsage.length > 0">
								<button *ngFor="let mode of timeModes" type="button" class="btn btn-sm"
									[ngClass]="{'btn-outline-secondary': mode.value !== timeMode, 'btn-secondary': mode.value === timeMode }"
									(click)="changeTimeMode(mode.value)">
									View by {{ mode.label }}
								</button>
							</div>

							<button *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv" type="button"
								class="btn btn-outline-secondary btn-sm me-1" (click)="toggleShowPhantom()">
								<fa-icon icon="minus"></fa-icon>
								Hide Meter/Protocol Comparison
							</button>

							<button *ngIf="meterProductsToShow.length > 0" type="button" class="btn btn-outline-secondary btn-sm me-1"
								(click)="updateMeterChart()" [disabled]="timeMode !== 'month'">
								<fa-icon [icon]="['fas', 'chart-line']"></fa-icon>
								Show Chart
							</button>

							<button *ngIf="canShowMeterProtocolEquiv && !showMeterProtocolEquiv" type="button"
								class="btn btn-outline-secondary btn-sm me-1" (click)="toggleShowPhantom()">
								<fa-icon icon="plus"></fa-icon>
								Show Meter/Protocol Comparison
							</button>
						</div>
						<div *ngIf="timeMode === 'month'" class="cp-65 mt-1">
							Click on a month's usage to get a day by day breakdown.
						</div>
					</div>

					<div class="row justify-content-start flex-nowrap">
						<div class="col-auto overflow-auto"
							[ngClass]="{ 'cp-75p-max-width': (byDayMeterLoading || byDayMeterProduct !== '') }">

							<div class="row justify-content-start">
								<div *ngFor="let product of meterProductsToShow" class="col-auto">
									<div class="fw-bold">
										{{ ac.meterTypeObjects[product].label }}
										<fa-icon [icon]="['fas', 'info-circle']" [ngbTooltip]="ac.meterTypeObjects[product].description"
											placement="bottom">
										</fa-icon>

										<div *ngIf="meterLabelsByType[product] && meterLabelsByType[product].length === 1"
											style="max-width:200px">
											{{ meterLabelsByType[product].join(', ') }}
										</div>
										<div *ngIf="meterLabelsByType[product] && meterLabelsByType[product].length > 1"
											style="max-width:200px">
											Multiple Labels
											<fa-icon [icon]="['fas', 'info-circle']" [ngbTooltip]="meterLabelsByType[product].join(', ')"
												placement="bottom">
											</fa-icon>
										</div>

										<div *ngIf="anyMeterLabels && (!meterLabelsByType[product] || meterLabelsByType[product].length === 0)"
											style="max-width:200px" class="font-italic">
											No Label Set
										</div>

									</div>
									<table class="cp-std-table cp-auto-width">
										<thead>
											<tr>
												<th class='cp-usage-center'>{{ timeModeLabel }}</th>
												<th class='cp-usage-center'>
													Used
													<span *ngIf="showRawData">(MB)</span>
												</th>
												<th *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													class='cp-usage-center'>
													<span ngbTooltip="Equivalent Amount Using Protocol Usage">
														P.E.
													</span>
												</th>
												<th *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													class='cp-usage-center'>
													<span ngbTooltip="Difference Between Meter Usage and Equivalent Protocol Usage">
														P.E. &Delta;
													</span>
												</th>
												<th *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													class='cp-usage-center'>
													<span ngbTooltip="Difference Between Meter Usage and Equivalent Protocol Usage">
														P.E. &Delta; %
													</span>
												</th>
												<th *ngIf="timeMode === 'month' && showOverageCounts[product] && +showOverageCounts[product] > 0"
													class='cp-usage-center'>
													<span
														ngbTooltip="Projected Amount of Traffic for this Month - based on monthly reset meter(s)">
														Projected
														<span *ngIf="showRawData">(MB)</span>
													</span>
												</th>
												<th *ngIf="timeMode === 'month' && showOverageCounts[product] && +showOverageCounts[product] > 0"
													class='cp-usage-center'>
													<span ngbTooltip="Amount of traffic over projected amount for the month">
														Over
														<span *ngIf="showRawData">(MB)</span>
													</span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let record of pullUsageForMeterProduct(product)">
												<td class="cp-usage-left">
													{{ makeTimeChunkHeader(record.month, record.year, false) }}
												</td>
												<td class="cp-usage-right cp-pointer"
													(click)="selectMeterDayToFocus(product, record.year, record.month)">
													<span [ngbTooltip]="makeDataTip(record.used, true, true)" ngxClipboard
														[cbContent]="record.used">
														{{ showDataValue(record.used) }}
													</span>
												</td>
												<td *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													[class]="productClass(getPhantomProduct(product)) + ' cp-usage-right text-nowrap'">
													<span ngxClipboard
														[cbContent]="getUsageForProtocolForTimeChunk(getPhantomProduct(product), record.year, record.month)">
														{{
														showDataValue(getUsageForProtocolForTimeChunk(getPhantomProduct(product),
														record.year,
														record.month)) }}
													</span>
												</td>

												<td *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													[class]="productClass(getPhantomProduct(product)) + ' cp-usage-right text-nowrap'">
													<span>
														{{ showDataValue(record.used -
														getUsageForProtocolForTimeChunk(getPhantomProduct(product),
														record.year, record.month)) }}
													</span>
												</td>
												<td *ngIf="canShowMeterProtocolEquiv && showMeterProtocolEquiv && chunkedProtocolUsage.length > 0"
													[class]="productClass(getPhantomProduct(product)) + ' cp-usage-right text-nowrap'">
													<span>
														{{ phantomPercent(record.used,
														getUsageForProtocolForTimeChunk(getPhantomProduct(product),
														record.year, record.month)) }}
													</span>
												</td>

												<td *ngIf="timeMode === 'month' && showOverageCounts[product] && +showOverageCounts[product] > 0"
													class="cp-usage-right">
													<span [ngbTooltip]="makeDataTip(workoutMonthsProjected(record), true, false)"
														ngxClipboard [cbContent]="workoutMonthsProjected(record)">
														{{ showDataValue(workoutMonthsProjected(record)) }}
													</span>
												</td>
												<td *ngIf="timeMode === 'month' && showOverageCounts[product] && +showOverageCounts[product] > 0"
													class="cp-usage-right">
													<span [ngbTooltip]="makeDataTip(workoutMonthsOverage(record), true, false)" ngxClipboard
														[cbContent]="workoutMonthsOverage(record)">
														{{ showDataValue(workoutMonthsOverage(record)) }}
													</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="tab-pane" role="tabpanel" id="nav-protocol-traffic" aria-labelledby="nav-protocol-traffic-tab">
				<div *ngIf="protocolProductsToShow.length > 0">
					<div *ngIf="filterID !== 0 && activationIDsWithUsage.length > 1">
						Showing usage for <span class="fw-bold">{{ hostid }}</span> using <span class="fw-bold">{{ filterKey
							}}</span>
						<!-- <span *ngIf="activationIDsWithUsage.length > 1" (click)="filterTraffic(0)" class="ms-1"
						ngbTooltip="Remove filter and show all usage">
						<fa-icon icon="times-circle"></fa-icon>
					</span> -->
					</div>

					<!-- <div *ngIf="activation && activation.discard_licenses === 1" class="cp-light-message mb-1">
					Only showing usage for the last {{ ac.keyUsageMonthsBackForDiscardKeys }} months.
				</div> -->

					<div class="mb-1 text-start">
						<div>
							<button *ngIf="showProtocolTraffic" type="button" class="btn btn-outline-secondary btn-sm me-1"
								(click)="openUsageReport('protocol-data')" placement="bottom-start"
								ngbTooltip="Get a spreadsheet with all monthly and daily protocol usage data">
								<fa-icon icon="file-excel"></fa-icon>
								Detailed Protocol Traffic Report
							</button>

							<button type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="toggleAxis()"
								ngbTooltip="Swap Axis/Rotate" placement="bottom-start">
								<fa-icon [icon]="['fas', 'ruler-triangle']" [rotate]="rotateAxis ? 90 : 0">
								</fa-icon>
							</button>

							<div class="btn-group me-1">
								<button *ngFor="let mode of timeModes" type="button" class="btn btn-sm"
									[ngClass]="{'btn-outline-secondary': mode.value !== timeMode, 'btn-secondary': mode.value === timeMode }"
									(click)="changeTimeMode(mode.value)">
									View by {{ mode.label }}
								</button>
							</div>

							<button *ngIf="showSetsButton" type="button" class="btn btn-outline-secondary btn-sm me-1"
								data-bs-toggle="offcanvas" data-bs-target="#protocol-sets-panel" aria-controls="protocol-sets-panel">
								<fa-icon [icon]="['fas', 'tasks']">
								</fa-icon>
								Protocol Sets
							</button>

							<button *ngIf="usedProtocolBillingCodes && usedProtocolBillingCodes.length > 0" type="button"
								class="btn btn-outline-secondary btn-sm me-1" data-bs-toggle="offcanvas"
								data-bs-target="#protocol-billing-codes-panel" aria-controls="protocol-billing-codes-panel">
								<fa-icon [icon]="['fas', 'sack-dollar']">
								</fa-icon>
								Billing Codes
							</button>

							<button *ngIf="onlyShowTotals" type="button" class="btn btn-outline-secondary btn-sm me-1"
								(click)="toggleTotalsOnly()">
								<fa-icon [icon]="['fas', 'abacus']"></fa-icon>
								Show All Protocols
							</button>

							<button *ngIf="!onlyShowTotals" type="button" class="btn btn-outline-secondary btn-sm me-1"
								(click)="toggleTotalsOnly()">
								<fa-icon [icon]="['fas', 'calculator']"></fa-icon>
								Just Show Totals
							</button>

							<button
								*ngIf="timeMode === 'month' && !protocolShowAllMonths && protocolTimeChunks.length > ac.protocolTrafficMonthsToShow"
								type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="toggleShowAllProtocolMonths()">
								<fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
								Show All {{ protocolTimeChunks.length }} Months
							</button>

							<button
								*ngIf="timeMode === 'month' && protocolShowAllMonths && protocolTimeChunks.length > ac.protocolTrafficMonthsToShow"
								type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="toggleShowAllProtocolMonths()">
								<fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
								Just Show Last {{ ac.protocolTrafficMonthsToShow }} Months
							</button>
						</div>
					</div>

					<div *ngIf="showBrandFilters && uniqueProtocolBrands.length > 0">
						Brands:
						<span *ngFor="let item of uniqueProtocolBrands; let i = index">
							{{ i > 0 ? ' ' + ac.bullet + ' ' : '' }}
							<span *ngIf="item == null" [ngClass]="brandFilter !== item ? 'cp-pointer text-info' : ''"
								(click)="setBrandFilter(item)">
								[null]
							</span>
							<span *ngIf="item === ''" [ngClass]="brandFilter !== item ? 'cp-pointer text-info' : ''"
								(click)="setBrandFilter(item)">
								[empty]
							</span>
							<span *ngIf="item != null && item !== ''"
								[ngClass]="brandFilter !== item ? 'cp-pointer text-info' : 'border p-1 bg-info text-white rounded'"
								(click)="setBrandFilter(item)">
								{{ item }}
							</span>
						</span>
					</div>

					<div class="row justify-content-start flex-nowrap g-1">
						<div class="col-auto overflow-auto"
							[ngClass]="{ 'cp-75p-max-width': (byDayProtocolLoading || byDayProtocolProduct !== '') }">
							<!-- if there are billing codes being used with this Bx -->

							<div *ngIf="lotsOfBillingCodes" class="my-2 cp-85 cp-wider-width-limit">
								Because of the large ({{ usedProtocolBillingCodes.length | number }}) number of billing codes used with this
								key, the usage data for each billing code is not shown. To show the data for a specific billing code, open
								the Billing Codes panel (button above) and click the "+" button beside the billing code.
							</div>

							<div *ngIf="usedProtocolBillingCodes && usedProtocolBillingCodes.length > 0 && activeProtocolBillingCode !== -1"
								class="my-2">
								<span class="cp-table-orange p-2">
									<fa-icon (click)="selectProtocolBillingCodeFilter(-2)" [icon]="['fas', 'times-circle']"
										ngbTooltip="Remove this filter">
									</fa-icon>
									Filter:
									<span class="fw-bold">
										{{ activeProtocolBillingCodeLabel }}
									</span>
								</span>
							</div>

							<div *ngIf="timeMode === 'month'" class="cp-65">
								Click on a month's usage to get a day by day breakdown.
							</div>

							<table *ngIf="protocolProductsVisible.length > 0 && rotateAxis"
								class="table table-sm table-hover table-bordered cp-auto-width">
								<thead>
									<tr>
										<th class='border text-start'>
											Protocol
										</th>
										<th class='border text-center'>
											<fa-icon [icon]="['fas', 'chart-line']"></fa-icon>
										</th>
										<th *ngFor="let ym of protocolTimeChunksToShow" class="border text-center cp-pre-text">
											{{ makeTimeChunkHeader(ym.month, ym.year, true) }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let pInfo of protocolsInfo">
										<td [class]="pInfo.protocolClass + ' text-start text-nowrap fw-bold'"
											[ngbPopover]="protocolPopupContent" popoverClass="cp-popover-std"
											triggers="mouseenter:mouseleave" container="body">
											{{ pInfo.niceProtocolShort }}
											<span *ngIf="showRawData">(MB)</span>
											<sup *ngIf="pInfo.superScript" [ngClass]="pInfo.superScriptClass">
												{{ pInfo.superScript }}
											</sup>
										</td>
										<td [class]="pInfo.protocolClass + ' text-center'">
											<button *ngIf="protocolTimeChunksToShow.length > 1" type="button"
												class="btn btn-sm btn-outline-info" (click)="updateProtocolChart(pInfo.protocol, true)"
												[disabled]="timeMode !== 'month' || pInfo.protocol.startsWith('pset-percent-used:')">
												<fa-icon [icon]="['fas', 'chart-line']"></fa-icon>
											</button>
										</td>

										<td *ngFor="let ym of protocolTimeChunksToShow"
											[class]="pInfo.protocolClass + ' text-end text-nowrap cp-pointer'">
											<span *ngIf="pInfo.protocol.startsWith('pset-percent-used:')" placement="top-end"
												[ngbTooltip]="makeExpDataTip(pInfo.protocol, ym, getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month), true, true)">
												{{ getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month) }}%
											</span>
											<span *ngIf="!pInfo.protocol.startsWith('pset-percent-used:')" placement="top-end"
												[ngbTooltip]="makeExpDataTip(pInfo.protocol, ym, getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month), true, true)"
												(click)="selectProtocolDayToFocus(pInfo.protocol, ym.year, ym.month)" ngxClipboard
												[cbContent]="getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month)">
												{{ showDataValue(getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year,
												ym.month)) }}
											</span>
										</td>

										<ng-template #protocolPopupContent>
											<div class="cp-popover-banner">{{ pInfo.niceProtocolLong }}</div>
											<div class="cp-pre-text" [innerHTML]="pInfo.popoverLines"> </div>
										</ng-template>
									</tr>
								</tbody>
							</table>

							<table *ngIf="protocolProductsVisible.length > 0 && !rotateAxis"
								class="table table-sm table-hover table-bordered cp-auto-width">
								<thead>
									<tr>
										<th class='border text-start'>
											{{ timeModeLabel }}
										</th>

										<th *ngFor="let pInfo of protocolsInfo" [class]="pInfo.protocolClass + ' text-center cp-pre-text'"
											[ngbPopover]="protocolPopupContent" popoverClass="cp-popover-std"
											triggers="mouseenter:mouseleave" container="body">
											{{ pInfo.niceProtocolShort }}
											<span *ngIf="showRawData">(MB)</span>
											<sup *ngIf="pInfo.superScript !== ''"
												[ngClass]="{'text-warning': !pInfo.protocol.startsWith('protocol-set:')}">
												{{ pInfo.superScript }}
											</sup>

											<ng-template #protocolPopupContent>
												<div class="cp-popover-banner">{{ pInfo.niceProtocolLong }}</div>
												<div class="cp-pre-text" [innerHTML]="pInfo.popoverLines"> </div>
											</ng-template>
											<div *ngIf="protocolTimeChunksToShow.length > 1">
												<button type="button" class="btn btn-outline-info btn-sm"
													(click)="updateProtocolChart(pInfo.protocol, true)"
													[disabled]="timeMode !== 'month' || pInfo.protocol.startsWith('pset-percent-used:')">
													<fa-icon [icon]="['fas', 'chart-line']"></fa-icon>
												</button>
											</div>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let ym of protocolTimeChunksToShow">
										<td class="cp-usage-left fw-bold cp-pre-text">
											{{ makeTimeChunkHeader(ym.month, ym.year, false) }}
										</td>
										<td *ngFor="let pInfo of protocolsInfo"
											[class]="pInfo.protocolClass + ' text-end text-nowrap cp-pointer'">
											<span *ngIf="pInfo.protocol.startsWith('pset-percent-used:')" placement="top-end"
												[ngbTooltip]="makeExpDataTip(pInfo.protocol, ym, getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month), true, true)">
												{{ getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month) }}%
											</span>
											<span *ngIf="!pInfo.protocol.startsWith('pset-percent-used:')" placement="top-end"
												[ngbTooltip]="makeExpDataTip(pInfo.protocol, ym, getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month), true, true)"
												(click)="selectProtocolDayToFocus(pInfo.protocol, ym.year, ym.month)" ngxClipboard
												[cbContent]="getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year, ym.month)">
												{{ showDataValue(getUsageForProtocolForTimeChunk(pInfo.protocol, ym.year,
												ym.month)) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div> <!-- tabset -->
	</div>

	<button type="button" id="open-meters-chart-modal" [hidden]="true" data-bs-toggle="modal" data-bs-target="#meters-chart-modal"></button>
	<div class="modal" data-bs-backdrop="static" data-bs-keyboard="false" id="meters-chart-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
			<div class="modal-content gg-modal-border">
				<div class="modal-header">
					<h5 class="modal-title">
						<span [innerHTML]="meterChartLabel"></span>
					</h5>
					<button type="button" class="btn-close" aria-hidden="true" data-bs-dismiss="modal" aria-label="Close"
						id="close-meters-chart-modal"></button>
				</div>
				<div class="modal-body">

					<div *ngIf="showMeterChart">
						<div class="mt-4 border p-2">
							<div>
								<span class="text-nowrap">
									<button type="button" class="btn btn-sm btn-outline-info ms-1" (click)="changeChartDirection()"
										ngbTooltip="Reverse Timeline">
										<fa-icon [icon]="['fas', 'arrows-left-right']"></fa-icon>
									</button>
									<button type="button" class="btn btn-sm btn-outline-info ms-1" (click)="changeIncludeCurrentMonth()"
										ngbTooltip="Include/Do not Include Current Month">
										<fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
									</button>
								</span>
							</div>
							<canvas #meterChart baseChart [data]="meterChartData" [options]="meterChartOptions"
								[type]="lineChartType"></canvas>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>

	<button type="button" id="open-protocol-chart-modal" [hidden]="true" data-bs-toggle="modal"
		data-bs-target="#protocol-chart-modal"></button>
	<div class="modal" data-bs-backdrop="static" data-bs-keyboard="false" id="protocol-chart-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
			<div class="modal-content gg-modal-border">
				<div class="modal-header">
					<h5 class="modal-title">
						<span [innerHTML]="protocolChartLabel"></span>
					</h5>
					<button type="button" class="btn-close" aria-hidden="true" data-bs-dismiss="modal" aria-label="Close"
						id="close-protocol-chart-modal"></button>
				</div>
				<div class="modal-body">

					<div *ngIf="showProtocolChart">
						<div id="protocolChart"></div>
						<div class="mt-4 border p-2">
							<div>
								<span class="text-nowrap">
									<button type="button" class="btn btn-sm btn-outline-info ms-1" (click)="changeChartDirection()"
										ngbTooltip="Reverse Timeline">
										<fa-icon [icon]="['fas', 'arrows-left-right']"></fa-icon>
									</button>
									<button type="button" class="btn btn-sm btn-outline-info ms-1" (click)="changeIncludeCurrentMonth()"
										ngbTooltip="Include/Do not Include Current Month">
										<fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
									</button>
								</span>
							</div>
							<canvas baseChart #protocolChart [data]="protocolChartData" [options]="protocolChartOptions"
								[type]="lineChartType"></canvas>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>

	<div class="modal" id="usage-summary-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Usage Summary Report by Host ID</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-usage-summary-modal">
					</button>
				</div>

				<div class="modal-body">

					<form *ngIf="usageSummaryForm" [formGroup]="usageSummaryForm" autocomplete="off">

						<div class="form-group">
							<label for="dataTypes">Report Data Types</label>
							<ng-select [items]="usageSummaryDataTypeSelections" bindValue="value" bindLabel="label" id="dataTypes"
								formControlName="dataTypes" [multiple]="true" [closeOnSelect]="false">
							</ng-select>
						</div>

						<div class="text-center mt-2">
							<button type="button" (click)="runKeyUsageSummaryReport()" class="btn btn-sm btn-outline-secondary"
								[disabled]="!usageSummaryForm.valid">
								<fa-icon icon="file-excel"></fa-icon>
								Generate Report
							</button>
						</div>

						<div class="cp-form-padding">
							The report will include one tab/sheet for each data type. Each data type's tab/sheet will have a
							column for each month that data was reported and a row with the amount for that month for each
							activated host ID and a row for the key's overal usage.
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>

	<div class="modal" id="link-offline-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Link Offline License to Offline Key</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-link-offline-modal">

					</button>
				</div>

				<div class="modal-body">

					<form *ngIf="linkOfflineForm" [formGroup]="linkOfflineForm" autocomplete="off">

						<div class="form-group">
							<label for="linkKey">Key</label>
							<input type="text" id="linkKey" formControlName="linkKey" class="form-control" />
						</div>

						<div class="text-center mt-2">
							<button type="button" (click)="linkOfflineLicenseToKey()" class="btn btn-sm btn-outline-secondary"
								[disabled]="!linkOfflineForm.valid">
								<fa-icon [icon]="['fas', 'link']"></fa-icon>
								Link License to Key
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>

	<div class="modal" id="manual-marketplace-report-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Manually Submit Marketplace Report</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						id="close-manual-marketplace-report-modal">

					</button>
				</div>

				<div class="modal-body">

					<form *ngIf="manualMarketplaceForm" [formGroup]="manualMarketplaceForm" autocomplete="off">
						<div class="form-group">
							<label for="amountGB">Amount to Report (GB)</label>
							<input type="text" id="amountGB" formControlName="amountGB" class="form-control" />
						</div>

						<div class="form-group">
							<label for="reportStart">Start of Report (yyyy/mm/dd hh:mm UTC)</label>
							<input type="text" id="reportStart" formControlName="reportStart" class="form-control" />
						</div>

						<div class="form-group">
							<label for="reportEnd">End of Report (yyyy/mm/dd hh:mm UTC)</label>
							<input type="text" id="reportEnd" formControlName="reportEnd" class="form-control" />
						</div>

						<div class="text-center mt-2">
							<button type="button" (click)="manualMarketplaceKeyReport()" class="btn btn-sm btn-outline-secondary"
								[disabled]="!manualMarketplaceForm.valid">
								<fa-icon [icon]="['fas', 'link']"></fa-icon>
								Report Usage to Marketplace
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>

	<button type="button" id="open-edit-key-label-modal" [hidden]="true" data-bs-toggle="modal"
		data-bs-target="#edit-key-label-modal"></button>
	<div class="modal" id="edit-key-label-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Set a Label for Your License Keys</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-edit-key-label-modal">
					</button>
				</div>

				<div class="modal-body">
					<form *ngIf="editKeyLabelForm" [formGroup]="editKeyLabelForm">
						<div class="cp-general-width-limit">
							<div class="form-group">
								<label for="label">Label</label>
								<input type="text" id="label" formControlName="label" class="form-control" />
							</div>
						</div>

						<div class="text-center">
							<button class="btn btn-primary me-1" type="button" (click)="saveKeyLabel()"
								[disabled]="!editKeyLabelForm.valid || saving">
								<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
							</button>
							<button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal" [disabled]="saving">
								<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>

	<button type="button" id="open-set-hostid-labels-modal" [hidden]="true" data-bs-toggle="modal"
		data-bs-target="#set-hostid-labels-modal"></button>
	<div class="modal" id="set-hostid-labels-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Set Label(s) for Host ID(s)</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-set-hostid-labels-modal">
					</button>
				</div>

				<div class="modal-body">
					<form *ngIf="addHostIdLabelsForm" [formGroup]="addHostIdLabelsForm">

						<div class="cp-general-width-limit">
							<div class="form-group">
								<label for="pairsList">Host ID(s) and Label(s)*</label>
								<textarea id="pairsList" formControlName="pairsList" class="form-control" rows="8"></textarea>
							</div>

							<div class="form-group">
								Enter host IDs and labels (separated by a space) in the box above. One pair per line.
							</div>
						</div>

						<div class="text-center">
							<button class="btn btn-primary me-1" type="button" (click)="saveHostIdLabels()"
								[disabled]="!addHostIdLabelsForm.valid || saving">
								<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
							</button>
							<button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal" [disabled]="saving">
								<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>

	<button type="button" id="open-edit-hostid-label-modal" [hidden]="true" data-bs-toggle="modal"
		data-bs-target="#edit-hostid-label-modal"></button>
	<div class="modal" id="edit-hostid-label-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Set Label for Host ID</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-edit-hostid-label-modal">
					</button>
				</div>

				<div class="modal-body">
					<form *ngIf="editHostIdLabelForm" [formGroup]="editHostIdLabelForm">
						<div class="cp-general-width-limit">
							<div class="form-group">
								<label for="label">Label for {{ hostid }}</label>
								<input type="text" id="label" formControlName="label" class="form-control" />
							</div>
						</div>
						<div class="text-center">
							<button class="btn btn-primary me-1" type="button" (click)="saveHostIdLabel()"
								[disabled]="!editHostIdLabelForm.valid || saving">
								<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
							</button>
							<button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal" [disabled]="saving">
								<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>


	<button type="button" id="open-edit-key-snooze-modal" [hidden]="true" data-bs-toggle="modal"
		data-bs-target="#edit-key-snooze-modal"></button>
	<div class="modal" id="edit-key-snooze-modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Snooze/Pause Notifications</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-edit-key-snooze-modal">
					</button>
				</div>

				<div class="modal-body">
					<form *ngIf="snoozeForm" [formGroup]="snoozeForm">

						<div class="cp-general-width-limit">
							<div class="cp-compact-form-group">
								<label for="expires_at">
									Resume Notifications On
									<fa-icon [icon]="['fas', 'question-circle']" placement="end"
										ngbTooltip="When should this snooze/pause expire?">
									</fa-icon>
								</label>
								<div class="input-group">
									<button class="btn btn-outline-secondary" (click)="expires_at.toggle()" type="button">
										<fa-icon icon="calendar-alt"></fa-icon>
									</button>

									<input class="form-control" placeholder="yyyy-mm-dd" id="expires_at" formControlName="expires_at"
										ngbDatepicker firstDayOfWeek="7" #expires_at="ngbDatepicker" style="max-width:14ch" />

									<button class="btn btm-sm btn-outline-secondary" (click)="increaseSnoozeExpiry(-1, 'next-month')"
										type="button" ngbTooltip="Set the date to the first day of next month">
										Start of Next Month
									</button>

									<button *ngFor="let dateMathButton of ac.dateMathButtons" class="btn btm-sm btn-outline-secondary"
										(click)="increaseSnoozeExpiry(dateMathButton.amount, dateMathButton.unit)" type="button"
										ngbTooltip="Add this amount of time to the entered date">
										{{ dateMathButton.label }}
									</button>
								</div>
							</div>

							<div class="form-group">
								<label for="snooze_type">Type of Notifications to Snooze/Pause</label>
								<div class="form-check" *ngFor="let selection of ac.keySnoozeTypes">
									<input class="form-check-input" type="radio" formControlName="snooze_type" name="snooze_type"
										[id]="'snooze_type_' + selection.value" [value]="selection.value" />
									<label class="form-check-label" [for]="'snooze_type_' + selection.value">
										<strong>{{ selection.label }}</strong> : {{ selection.description }}
									</label>
								</div>
							</div>
						</div>

						<div *ngFor="let err of snoozeErrors" class="cp-form-error">
							{{ err }}
						</div>

						<div class="text-center">
							<button class="btn btn-primary me-1" type="button" (click)="saveKeySnooze()"
								[disabled]="!snoozeForm.valid || saving">
								<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
							</button>
							<button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal" [disabled]="saving">
								<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
							</button>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>



	<button type="button" [hidden]="true" id="open-protocol-sets-panel" data-bs-toggle="offcanvas" data-bs-target="#protocol-sets-panel"
		aria-controls="protocol-sets-panel">
	</button>
	<div class="offcanvas offcanvas-end" tabindex="-1" id="protocol-sets-panel" aria-labelledby="protocol-sets-panel-label">
		<div class="offcanvas-header border p-2 ps-3">
			<h5 class="offcanvas-title" id="protocol-sets-panel-label">
				Protocol Sets (Data Usage)
			</h5>
			<button type="button" class="btn-close" id="close-protocol-sets-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		</div>
		<div class="offcanvas-body border p-2">
			<div class="text-center">
				<button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleSetsPosition()">
					<fa-icon [icon]="['fas', 'sort-alt']"></fa-icon>
					Show {{ protocolSetsPosition === 'bottom' ? 'Before' : 'After' }} Other Data
				</button>
			</div>

			<div *ngIf="supportsLinkedSet && (canLinkProtocolSets || linkedProtocolSets.length > 0)" class="mt-2 border-top text-center">
				<span class="fw-bold">
					Linked Sets
					<button *ngIf="activation && actionsReady && canManageCommercial" type="button"
						class="btn btn-outline-primary btn-sm ms-1 mb-1"
						[routerLink]="['/' + ac.urls.licensing, activation.id, 'commercial']" data-bs-dismiss="offcanvas"
						ngbTooltip="Manage Linked Protocol Sets">
						<fa-icon icon="pencil"></fa-icon>
						Manage
					</button>
				</span>
				<div *ngIf="linkedProtocolSets.length === 0" class="font-italic">
					None
				</div>

				<div *ngIf="linkedProtocolSets.length !== 0" class="row">
					<div *ngFor="let protocolSet of linkedProtocolSets" class="col-12 mb-1">
						<button type="button" class="btn btn-outline-secondary btn-sm w-100" [ngbPopover]="pSetPopupContent"
							popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
							<fa-icon [icon]="['fas', 'link']"></fa-icon>
							{{ protocolSet.name }}
						</button>

						<ng-template #pSetPopupContent>
							<app-card-protocol-set [object]="protocolSet" [forStaff]="true"></app-card-protocol-set>
						</ng-template>
					</div>
				</div>
			</div>

			<div *ngIf="supportsSessionSet" class="mt-2 border-top text-center">
				<span class="fw-bold">Session Sets</span>
				<div *ngIf="sessionProtocolSets.length === 0" class="font-italic">
					None
				</div>

				<div *ngIf="sessionProtocolSets.length !== 0" class="row">
					<div *ngFor="let protocolSet of sessionProtocolSets" class="col-12 mb-1">
						<button type="button" class="btn btn-outline-danger btn-sm w-100"
							(click)="toggleSessionSet(protocolSet.id, 'protocol-data')" [ngbPopover]="pSetPopupContent"
							popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
							<fa-icon [icon]="['fas', 'minus']"></fa-icon>
							{{ protocolSet.name }}
						</button>

						<ng-template #pSetPopupContent>
							<app-card-protocol-set [object]="protocolSet" [forStaff]="true"></app-card-protocol-set>
						</ng-template>
					</div>
				</div>
			</div>

			<div *ngIf="supportsSessionSet && filterOutSelected(selectedProtocolSets).length > 0" class="mt-2 border-top text-center">
				<div class="fw-bold">Available Sets</div>
				<div class="cp-85">Click to Add as Session Set</div>
				<div class="row">
					<div *ngFor="let protocolSet of filterOutSelected(selectedProtocolSets)" class="col-12 mb-1">
						<button type="button" class="btn btn-outline-success btn-sm w-100"
							(click)="toggleSessionSet(protocolSet.id, 'protocol-data')" [ngbPopover]="pSetPopupContent"
							popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
							<fa-icon [icon]="['fas', 'plus']"></fa-icon>
							{{ protocolSet.name }}
						</button>

						<ng-template #pSetPopupContent>
							<app-card-protocol-set [object]="protocolSet" [forStaff]="true"></app-card-protocol-set>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>

	<button type="button" [hidden]="true" id="open-protocol-billing-codes-panel" data-bs-toggle="offcanvas"
		data-bs-target="#protocol-billing-codes-panel" aria-controls="protocol-billing-codes-panel">
	</button>
	<div class="offcanvas offcanvas-end cp-wide-off-canvas" tabindex="-1" id="protocol-billing-codes-panel"
		aria-labelledby="protocol-billing-codes-panel-label">
		<div class="offcanvas-header border p-2 ps-3">
			<h5 class="offcanvas-title" id="protocol-billing-codes-panel-label">
				Billing Codes (Data Usage)
			</h5>
			<button type="button" class="btn-close" id="close-protocol-sets-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		</div>
		<div class="offcanvas-body border p-2">
			<div class="text-center">
				<button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleBillingCodeDisplay()">
					Toggle Showing Code vs. Label
				</button>
			</div>
			<div class="text-center mt-1">
				<button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleSetsPosition()">
					<fa-icon [icon]="['fas', 'sort-alt']"></fa-icon>
					Show {{ protocolSetsPosition === 'bottom' ? 'Before' : 'After' }} Other Data
				</button>
			</div>

			<div *ngIf="lotsOfBillingCodes" [ngClass]="{'border border-info': billingCodeFilter && billingCodeFilter !== ''}"
				class="mx-auto my-1" style="width: 200px">
				<div class="input-group">
					<input type="search" id="bcTextFilter" class="form-control form-control-sm" (keyup)="billlingCodeFilterChangeHandler()"
						(search)="updateBilllingCodeFilter()" placeholder="Search" [value]="billingCodeFilter"
						[ngClass]="{'bg-info': billingCodeFilter && billingCodeFilter !== ''}" />
					<button type="button" class="btn btn-close bg-transparent" style="padding-top: 14px; margin-left: -25px; z-index: 100;"
						(click)="resetBilllingCodeFilter()" ngbTooltip="Clear Search"
						[hidden]="!billingCodeFilter || billingCodeFilter === ''">
					</button>
				</div>
			</div>

			<table class="mx-auto">
				<tr>
					<td class="text-end">
						<button *ngIf="activeProtocolBillingCode === -1" type="button" class="btn btn-outline-secondary btn-sm me-1"
							disabled>
							Current
						</button>
						<button *ngIf="activeProtocolBillingCode !== -1" type="button" class="btn btn-outline-info btn-sm me-1"
							(click)="selectProtocolBillingCodeFilter(-1)">
							Remove Filter
						</button>
					</td>
					<td class="fw-bold">
						<span *ngIf="activeProtocolBillingCode === -1">All usage data</span>
					</td>
				</tr>

				<tr class="border-top">
					<td class="text-end">
						<button *ngIf="activeProtocolBillingCode === 0" type="button" class="btn btn-outline-secondary btn-sm me-1"
							disabled>
							Current
						</button>
						<button *ngIf="activeProtocolBillingCode !== 0" type="button"
							class="btn btn-outline-secondary btn-sm me-1 text-nowrap" (click)="selectProtocolBillingCodeFilter(0)">
							<fa-icon [icon]="['fas', 'filter']"></fa-icon>
							Filter
						</button>
					</td>
					<td class="fw-bold">
						Usage data with no billing code set
					</td>
				</tr>

				<tr *ngFor="let bc of usedProtocolBillingCodesToShow" class="border-top">
					<td class="text-end">
						<button *ngIf="activeProtocolBillingCode === bc.id" type="button" class="btn btn-outline-secondary btn-sm me-1"
							disabled>
							Current
						</button>
						<button *ngIf="activeProtocolBillingCode !== bc.id" type="button"
							class="btn btn-outline-info btn-sm me-1 text-nowrap" (click)="selectProtocolBillingCodeFilter(bc.id)">
							<fa-icon [icon]="['fas', 'filter']"></fa-icon>
							Filter
						</button>
					</td>
					<td class="fw-bold">
						{{ makeBillingCodeLabel(bc) }}
					</td>
					<td *ngIf="lotsOfBillingCodes && activeProtocolBillingCode === -1">
						<button *ngIf="activeProtocolBillingCode !== bc.id" type="button" class="btn btn-sm ms-1"
							[ngClass]="protocolProductsVisible.includes('billing-code:' + bc.billing_code) ? 'btn-info' : 'btn-outline-info'"
							(click)="toggleBillingCodeData(bc.billing_code)">
							<fa-icon
								[icon]="['fas', protocolProductsVisible.includes('billing-code:' + bc.billing_code) ? 'minus' : 'plus' ]"></fa-icon>
						</button>
					</td>
				</tr>
			</table>
		</div>
	</div>

	<button type="button" [hidden]="true" id="open-license-features-panel" data-bs-toggle="offcanvas"
		data-bs-target="#license-features-panel" aria-controls="license-features-panel">
	</button>
	<div class="offcanvas offcanvas-end" tabindex="-1" id="license-features-panel" aria-labelledby="license-features-panel-label">
		<div class="offcanvas-header border p-2 ps-3">
			<h5 class="offcanvas-title" id="license-features-panel-label">
				Features + Limits
			</h5>
			<button type="button" class="btn-close" id="close-license-features-panel" data-bs-dismiss="offcanvas"
				aria-label="Close"></button>
		</div>
		<div *ngIf="showSelectedKeyLicFeatures" class="offcanvas-body border p-2">
			<app-key-features #hostFeatures></app-key-features>
		</div>
	</div>

	<button type="button" [hidden]="true" id="open-daily-meter-panel" data-bs-toggle="offcanvas" data-bs-target="#daily-meter-panel"
		aria-controls="daily-meter-panel">
	</button>
	<div class="offcanvas offcanvas-end" tabindex="-1" id="daily-meter-panel" aria-labelledby="daily-meter-panel-label">
		<div class="offcanvas-header border p-2 ps-3">
			<h5 class="offcanvas-title" id="daily-meter-panel-label">
				<div *ngIf="!byDayMeterLoading && byDayMeterProduct !== ''">
					{{ niceProtocol(byDayMeterProduct, true) }}
					{{ tt.getMonthName(byDayMeterMonth, true) }} {{ byDayMeterYear }}
				</div>
			</h5>
			<button type="button" class="btn-close" id="close-daily-meter-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		</div>
		<div class="offcanvas-body border p-2">
			<app-loading-spinner *ngIf="byDayMeterLoading"></app-loading-spinner>

			<table *ngIf="byDayMeterUsage.length > 0" class="cp-std-table mx-auto cp-auto-width">
				<thead>
					<tr>
						<th class="cp-usage-center">
							Day
						</th>
						<th class="cp-usage-center">
							Used
							<span *ngIf="showRawData">(MB)</span>
						</th>
						<th class="cp-usage-center" title="% change from previous day">
							% Chg.
						</th>
						<th class="cp-usage-center">
							Avg.<br />Rate<br />Mbits/s
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let record of byDayMeterUsage; let i = index">
						<td class="border text-center text-nowrap">{{ dayLabel(record) }}
						</td>
						<td class="cp-usage-right">
							<span [ngbTooltip]="makeDataTip(record.used)" ngxClipboard [cbContent]="record.used">
								{{ showDataValue(record.used) }}
							</span>
						</td>
						<td *ngIf="i === 0" class="cp-usage-right">-</td>
						<td *ngIf="i !== 0" class="cp-usage-right">
							{{ getDayToDayRatio('meter-data', i) | percent:percFmt }}
						</td>
						<td class="cp-usage-right">
							{{ dailyRate(record.used) | number:rateNumFmt }}
						</td>
					</tr>

					<tr *ngIf="byDayMeterUsage.length > 1">
						<th class="cp-usage-left">Total</th>
						<td class="cp-usage-right">
							<span [ngbTooltip]="makeDataTip(byDayMeterTotal)" ngxClipboard [cbContent]="byDayMeterTotal">
								{{ showDataValue(byDayMeterTotal) }}
							</span>
						</td>
						<td class="cp-usage-right"></td>
						<td class="cp-usage-right"></td>
					</tr>

					<tr *ngIf="byDayMeterUsage.length > 1">
						<th class="cp-usage-left">Avg.</th>
						<td class="cp-usage-right">
							<span [ngbTooltip]="makeDataTip(byDayMeterTotal / byDayMeterUsage.length, false)">
								{{ showDataValue(byDayMeterTotal / byDayMeterUsage.length) }}
							</span>
						</td>
						<td class="cp-usage-right">
							&plusmn; {{ byDayMeterAvgAbsChg | percent:percFmt }}
						</td>
						<td class="cp-usage-right">
							{{ dailyRate(byDayMeterTotal / byDayMeterUsage.length) | number:rateNumFmt
							}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<button type="button" [hidden]="true" id="open-daily-protocol-panel" data-bs-toggle="offcanvas" data-bs-target="#daily-protocol-panel"
		aria-controls="daily-protocol-panel">
	</button>
	<div class="offcanvas offcanvas-end" tabindex="-1" id="daily-protocol-panel" aria-labelledby="daily-protocol-panel-label">
		<div class="offcanvas-header border p-2 ps-3">
			<h5 class="offcanvas-title" id="daily-protocol-panel-label">
				<div *ngIf="!byDayProtocolLoading && byDayProtocolProduct !== ''">
					{{ niceProtocol(byDayProtocolProduct, true) }} -
					{{ tt.getMonthName(byDayProtocolMonth, true) }} {{ byDayProtocolYear }}
					<div *ngIf="activeProtocolBillingCodeShortLabel !== ''">
						{{ activeProtocolBillingCodeShortLabel }}
					</div>
				</div>
			</h5>
			<button type="button" class="btn-close" id="close-daily-protocol-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		</div>
		<div class="offcanvas-body border p-2">

			<app-loading-spinner *ngIf="byDayProtocolLoading"></app-loading-spinner>

			<table *ngIf="!byDayProtocolLoading && byDayProtocolUsage.length > 0"
				class="table table-sm table-bordered mx-auto cp-auto-width">
				<thead>
					<tr>
						<th class="cp-usage-center">
							Day
						</th>
						<th class="cp-usage-center">
							Used
							<span *ngIf="showRawData">(MB)</span>
						</th>
						<th class="cp-usage-center" title="% change from previous day">
							% Chg.
						</th>
						<th class="cp-usage-center">
							Avg.<br />Rate<br />Mbits/s
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let record of byDayProtocolUsage; let i = index">
						<td [class]="productClass(byDayProtocolProduct) + ' text-center text-nowrap'">
							{{ dayLabel(record) }}
						</td>
						<td [class]="productClass(byDayProtocolProduct) + ' text-end text-nowrap'">
							<span [ngbTooltip]="makeDataTip(record.used)" ngxClipboard [cbContent]="record.used">
								{{ showDataValue(record.used) }}
							</span>
						</td>
						<td *ngIf="i === 0" [class]="productClass(byDayProtocolProduct) + ' text-end text-nowrap'">-
						</td>
						<td *ngIf="i !== 0" [class]="productClass(byDayProtocolProduct) + ' text-end text-nowrap'">
							{{ getDayToDayRatio('protocol-data', i) | percent:percFmt }}
						</td>
						<td [class]="productClass(byDayProtocolProduct) + ' text-end text-nowrap'">
							{{ dailyRate(record.used) | number:rateNumFmt }}
						</td>
					</tr>

					<tr *ngIf="byDayProtocolUsage.length > 1" class="fw-bold">
						<th class="cp-usage-left">
							Total
						</th>
						<td class="cp-usage-right">
							<span [ngbTooltip]="makeDataTip(byDayProtocolTotal)" ngxClipboard [cbContent]="byDayProtocolTotal">
								{{ showDataValue(byDayProtocolTotal) }}
							</span>
						</td>
						<td class="cp-usage-left"></td>
						<td class="cp-usage-left"></td>
					</tr>

					<tr *ngIf="byDayProtocolUsage.length > 1" class="fw-bold">
						<th class="cp-usage-left">Avg.</th>
						<td class="cp-usage-right">
							<span [ngbTooltip]="makeDataTip(byDayProtocolTotal/byDayProtocolUsage.length, false)">
								{{ showDataValue(byDayProtocolTotal/byDayProtocolUsage.length) }}
							</span>
						</td>
						<td class="cp-usage-right">
							&plusmn; {{ byDayProtocolAvgAbsChg | percent:percFmt }}
						</td>
						<td class="cp-usage-right">
							{{ dailyRate(byDayProtocolTotal / byDayProtocolUsage.length) |
							number:rateNumFmt }}
						</td>
					</tr>
				</tbody>
			</table>

		</div>
	</div>
</div>

<app-popup-box [parentApi]="getParentMethod()"></app-popup-box>